{
  "translation": {
    "ADD_COMPANY.CODE.LABEL": "Code de l'entreprise",
    "ADD_COMPANY.COUNTRY.LABEL": "Pays",
    "ADD_COMPANY.COUNTRY.PLACEHOLDER": "Sélectionner un pays",
    "ADD_COMPANY.CURRENCY.LABEL": "Monnaie",
    "ADD_COMPANY.CURRENCY.PLACEHOLDER": "Sélectionner une devise",
    "ADD_COMPANY.LANGUAGE.LABEL": "Langue",
    "ADD_COMPANY.LOGO.LABEL": "Sélectionner un logo",
    "ADD_COMPANY.MEASUREMENT_TYPE.LABEL": "Type de mesure",
    "ADD_COMPANY.MEASUREMENT_TYPE.PLACEHOLDER": "Sélectionner un type de mesure",
    "ADD_COMPANY.NAME.LABEL": "Nom",
    "ADD_COMPANY.PARTNER.LABEL": "Partenaire",
    "ADD_COMPANY.PARTNER.PLACEHOLDER": "Sélectionner un partenaire",
    "ADD_COMPANY.RESPONSE.SUCCESS": "La société a été créée avec succès",
    "ADD_COMPANY.SUBMIT": "Ajouter une nouvelle entreprise",
    "ADD_COMPANY.TITLE": "Ajouter une nouvelle entreprise",
    "ADD_COMPANY.VALIDATION.CODE": "Le code de l'entreprise est requis",
    "ADD_COMPANY.VALIDATION.COUNTRY": "Le pays est requis",
    "ADD_COMPANY.VALIDATION.CURRENCY": "La monnaie est obligatoire",
    "ADD_COMPANY.VALIDATION.IMAGE": "Le logo de l'entreprise est requis",
    "ADD_COMPANY.VALIDATION.LANGUAGE": "La langue est obligatoire",
    "ADD_COMPANY.VALIDATION.MEASUREMENT_TYPE": "Le type de mesure est requis",
    "ADD_COMPANY.VALIDATION.NAME": "Le nom est obligatoire",
    "ADD_COMPANY.VALIDATION.PARTNER": "Un partenaire est nécessaire",
    "ADD_FLOW_DATA.BTN.FLOW_DATA": "Ajouter des données de débit",
    "ADD_FLOW_DATA.BTN.SUBMIT": "Soumettre",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.LABEL": "Date et heure des données de débit",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.PLACEHOLDER": "Cliquez ici pour sélectionner la date et l'heure",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.LABEL": "Valeur",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.PLACEHOLDER": "Valeur des données de débit",
    "ADD_FLOW_DATA.MODAL.ERROR.DESC": "Veuillez réessayer les données de flux n'ont pas été mises à jour.",
    "ADD_FLOW_DATA.MODAL.ERROR.TITLE": "Réessayez !",
    "ADD_FLOW_DATA.MODAL.SUCCESS.DESC": "Les données de flux ont été mises à jour",
    "ADD_FLOW_DATA.MODAL.SUCCESS.TITLE": "Génial !",
    "ADD_PARTNER.ADDRESS.LABEL": "Adresse",
    "ADD_PARTNER.CODE.LABEL": "Code",
    "ADD_PARTNER.COUNTRY.LABEL": "Pays",
    "ADD_PARTNER.COUNTRY.PLACEHOLDER": "Sélectionner un pays",
    "ADD_PARTNER.CURRENCY.LABEL": "Monnaie",
    "ADD_PARTNER.CURRENCY.PLACEHOLDER": "Sélectionner une devise",
    "ADD_PARTNER.LOGO.LABEL": "Sélectionner un logo",
    "ADD_PARTNER.NAME.LABEL": "Nom",
    "ADD_PARTNER.RESPONSE.SUCCESS": "Le partenaire a été créé avec succès",
    "ADD_PARTNER.SUBMIT": "Ajouter un nouveau partenaire",
    "ADD_PARTNER.TITLE": "Ajouter un nouveau partenaire",
    "ADD_PARTNER.VALIDATION.ADDRESS": "L'adresse est obligatoire",
    "ADD_PARTNER.VALIDATION.CODE": "Le code est requis",
    "ADD_PARTNER.VALIDATION.COUNTRY": "Le pays est requis",
    "ADD_PARTNER.VALIDATION.CURRENCY": "La monnaie est obligatoire",
    "ADD_PARTNER.VALIDATION.IMAGE": "L'image du partenaire est requise",
    "ADD_PARTNER.VALIDATION.NAME": "Le nom est obligatoire",
    "ADD_PROJECT.COMPANY.LABEL": "Entreprise",
    "ADD_PROJECT.COMPANY.PLACEHOLDER": "Sélectionner une entreprise",
    "ADD_PROJECT.COST_PER_KM.LABEL": "Coût par KM ($)",
    "ADD_PROJECT.CURRENCY.LABEL": "Monnaie",
    "ADD_PROJECT.CURRENCY.PLACEHOLDER": "Sélectionner une devise",
    "ADD_PROJECT.DMAS.LABEL": "DMA",
    "ADD_PROJECT.DMAS.NO_MATCHING": "Pas de DMA correspondant",
    "ADD_PROJECT.DMAS.PLACEHOLDER": "Sélectionner les DMA",
    "ADD_PROJECT.END_DATE.LABEL": "Date de fin",
    "ADD_PROJECT.MEASUREMENT_TYPE.LABEL": "Type de mesure",
    "ADD_PROJECT.MEASUREMENT_TYPE.PLACEHOLDER": "Sélectionner un type de mesure",
    "ADD_PROJECT.NAME.LABEL": "Ajouter un nouveau projet",
    "ADD_PROJECT.RESPONSE.SUCCESS": "Le projet a été créé avec succès",
    "ADD_PROJECT.START_DATE.LABEL": "Date de début",
    "ADD_PROJECT.SUBMIT": "Créer un nouveau projet",
    "ADD_PROJECT.TITLE": "Ajouter un nouveau projet",
    "ADD_PROJECT.VALIDATION.COMPANY": "L'entreprise est tenue",
    "ADD_PROJECT.VALIDATION.COST_PER_KM": "Le coût par KM est requis",
    "ADD_PROJECT.VALIDATION.CURRENCY": "La monnaie est obligatoire",
    "ADD_PROJECT.VALIDATION.END_DATE": "La date de fin est requise",
    "ADD_PROJECT.VALIDATION.MEASUREMENT_TYPE": "Le type de mesure est requis",
    "ADD_PROJECT.VALIDATION.NAME": "Le nom est obligatoire",
    "ADD_PROJECT.VALIDATION.START_DATE": "La date de début est requise",
    "ADD_USER.MODAL.BTN.CLOSE": "Fermer la fenêtre modale",
    "ADD_USER.RESPONSE.SUCCESS": "L'utilisateur a été créé avec succès",
    "ADD_USER.SUBMIT": "Ajouter un nouvel utilisateur",
    "ADD_USER.TITLE": "Ajouter un nouvel utilisateur",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_ID": "ID de l'actif",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_TYPE": "Type d'actif normalisé",
    "ASSET_TOOLTIP.ERROR": "Impossible de récupérer les informations sur les actifs",
    "ASSET_TOOLTIP.NO_DATA": "Aucune information sur la session n'est disponible",
    "ASSET_TOOLTIP.TABLE.HEADER.1": "ID de la session",
    "ASSET_TOOLTIP.TABLE.HEADER.2": "ID du bogue",
    "ASSET_TOOLTIP.TABLE.HEADER.3": "Horodatage",
    "ASSET_TOOLTIP.TABLE.HEADER.4": "Résultats",
    "ASSET_TOOLTIP.TITLE.ASSET": "Informations sur les actifs",
    "ASSET_TOOLTIP.TITLE.SESSION": "Informations sur la session",
    "BREADCRUMB.FILTERS.COMPANY": "Entreprise",
    "BREADCRUMB.FILTERS.DATE_FROM": "Date du",
    "BREADCRUMB.FILTERS.DATE_TO": "Date à",
    "BREADCRUMB.FILTERS.DATEFROM": "Date du",
    "BREADCRUMB.FILTERS.DATETO": "Date à",
    "BREADCRUMB.FILTERS.DAY": "Jour",
    "BREADCRUMB.FILTERS.ENGINEER": "Ingénieur",
    "BREADCRUMB.FILTERS.PARTNER": "Partenaire",
    "BREADCRUMB.FILTERS.PROJECT": "Projet",
    "BROWSE_HOME_PAGE.TITLE": "Sélectionnez un type de données pour commencer la navigation.",
    "BROWSE_VIEW.BACK_TO_LIST": "Retour à la liste",
    "BROWSE_VIEW.MEDIA_SECTION.EMPTY_MSG": "Aucun média pour ce point de passage",
    "BROWSE_VIEW.MEDIA_SECTION.LABEL": "Médias",
    "BROWSE_VIEW.RELAY.ADDRESS": "Adresse",
    "BROWSE_VIEW.RELAY.DEPLOYED_BY": "Déployé par",
    "BROWSE_VIEW.RELAY.LAST_CONTACT": "Dernier contact",
    "BROWSE_VIEW.RELAY.LAST_UPLOADED": "Dernière mise en ligne",
    "BROWSE_VIEW.RELAY.NO_NAME_PLACEHOLDER": "Relais",
    "BROWSE_VIEW.RELAY.SESSION": "Session",
    "BROWSE_VIEW.RELAY.UPDATED": "Mis à jour",
    "BROWSE_VIEW.RELAY.W3W": "Quels 3 mots",
    "BROWSE_VIEW.SENSOR.BATTERY_VOLTAGE": "Tension de la batterie",
    "BROWSE_VIEW.SENSOR.COLLECTED_BY": "Collecté par",
    "BROWSE_VIEW.SENSOR.DEPLOYED_BY": "Déployé par",
    "BROWSE_VIEW.SENSOR.END_TIME": "Fin des temps",
    "BROWSE_VIEW.SENSOR.FIRMWARE_VERSION": "Version",
    "BROWSE_VIEW.SENSOR.LAST_UPLOADED": "Dernière mise en ligne",
    "BROWSE_VIEW.SENSOR.LATEST_SESSION": "Dernière session",
    "BROWSE_VIEW.SENSOR.SESSION": "Session",
    "BROWSE_VIEW.SENSOR.SESSION_TYPE": "Type de session",
    "BROWSE_VIEW.SENSOR.START_TIME": "Heure de début",
    "BROWSE_VIEW.SESSION.LAST_UPLOADED": "Dernière mise en ligne",
    "BROWSE_VIEW.WAYPOINT.ADD_JOB": "Ajouter une offre d'emploi",
    "BROWSE_VIEW.WAYPOINT.ADDRESS": "Adresse",
    "BROWSE_VIEW.WAYPOINT.CREATED": "Créé",
    "BROWSE_VIEW.WAYPOINT.DIAMETER": "Diamètre",
    "BROWSE_VIEW.WAYPOINT.ENG_NOTES": "Notes techniques",
    "BROWSE_VIEW.WAYPOINT.ENGINEER": "Ingénieur désigné",
    "BROWSE_VIEW.WAYPOINT.ENV_NOTES": "Notes environnementales",
    "BROWSE_VIEW.WAYPOINT.MATERIAL": "Matériau des tuyaux",
    "BROWSE_VIEW.WAYPOINT.MERGE_WP": "Point de passage de fusion",
    "BROWSE_VIEW.WAYPOINT.NO_NAME_PLACEHOLDER": "Point de passage non nommé",
    "BROWSE_VIEW.WAYPOINT.SECTION.ACTIVITIES": "Activités",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES": "Profils de consommation",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES_EMTPY": "Aucun profil de consommation pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS": "Corrélations",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS_EMPTY": "Aucune corrélation pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY": "Histoire",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY_EMPTY": "Aucun historique pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS": "Emplois",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS_EMPTY": "Aucun emploi pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES": "Notes",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES_EMPTY": "Aucune note pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS": "Séances",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS_EMPTY": "Aucune session pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS": "Sondages",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS_EMPTY": "Aucun sondage pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS": "Sondages de pointe",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS_EMPTY": "Aucun sondage de surface pour ce point de passage",
    "BROWSE_VIEW.WAYPOINT.UPDATED": "Mis à jour",
    "BROWSE_VIEW.WAYPOINT.W3W": "Quels 3 mots",
    "BROWSE.FILTERS.COLLECTED_BY": "Collecté par",
    "BROWSE.FILTERS.COLLECTED_BY_PLACEHOLDER": "Sélection collectée par l'utilisateur",
    "BROWSE.FILTERS.COMPANY": "Entreprise",
    "BROWSE.FILTERS.COMPANY_NAME": "Nom de l'entreprise",
    "BROWSE.FILTERS.COMPANY_PLACEHOLDER": "Entreprises sélectionnées",
    "BROWSE.FILTERS.DEPLOYED_BY": "Déployé par",
    "BROWSE.FILTERS.DEPLOYED_BY_PLACEHOLDER": "Sélectionner déployé par l'utilisateur",
    "BROWSE.FILTERS.DMA": "DMA",
    "BROWSE.FILTERS.DMA_KEY": "Clé DMA",
    "BROWSE.FILTERS.DMA_PLACEHOLDER": "Sélectionner les DMA",
    "BROWSE.FILTERS.FILTER": "Filtre",
    "BROWSE.FILTERS.FROM": "Depuis",
    "BROWSE.FILTERS.ID": "IDENTIFIANT",
    "BROWSE.FILTERS.JOB_TYPE": "Type d'emploi",
    "BROWSE.FILTERS.JOB_TYPE_PLACEHOLDER": "Sélectionnez les codes de type d'emploi",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER": "Dernier ingénieur programmé",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER_PLACEHOLDER": "Sélectionner les derniers ingénieurs planifiés",
    "BROWSE.FILTERS.LEAK_RESULTS": "Résultats de fuite",
    "BROWSE.FILTERS.LEAK_RESULTS_PLACEHOLDER": "Résultats de la sélection des fuites",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION": "Auteur le plus récent de la modification",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION_PLACEHOLDER": "Sélectionner les derniers utilisateurs actifs",
    "BROWSE.FILTERS.NAME": "Nom",
    "BROWSE.FILTERS.OTHERS": "Autres",
    "BROWSE.FILTERS.PARTNER": "Partenaire",
    "BROWSE.FILTERS.PARTNER_NAME": "Nom du partenaire",
    "BROWSE.FILTERS.PARTNER_PLACEHOLDER": "Partenaires sélectionnés",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE": "Type de fuite prévu",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE_PLACEHOLDER": "Sélectionnez les types de fuites prévus",
    "BROWSE.FILTERS.PREDICTED_SIZE": "Taille prévue",
    "BROWSE.FILTERS.PREDICTED_SIZE_PLACEHOLDER": "Sélectionnez les tailles prévues",
    "BROWSE.FILTERS.PREDICTED_SIZE.CORRELATION": "Corrélation",
    "BROWSE.FILTERS.PREDICTED_SIZE.ERROR": "Erreur",
    "BROWSE.FILTERS.PREDICTED_SIZE.LARGE": "Grand",
    "BROWSE.FILTERS.PREDICTED_SIZE.MEDIUM": "Moyen",
    "BROWSE.FILTERS.PREDICTED_SIZE.NA": "N / A",
    "BROWSE.FILTERS.PREDICTED_SIZE.NOT_ENOUGH_FILES": "Fichiers insuffisants",
    "BROWSE.FILTERS.PREDICTED_SIZE.SMALL": "Petit",
    "BROWSE.FILTERS.PROJECT": "Projet",
    "BROWSE.FILTERS.PROJECT_PLACEHOLDER": "Projets sélectionnés",
    "BROWSE.FILTERS.RELAY_CONNECTED": "Relais connecté",
    "BROWSE.FILTERS.RELAYS": "Relais",
    "BROWSE.FILTERS.SELECT_FIELD": "Sélectionner un champ",
    "BROWSE.FILTERS.SENSORS": "Capteurs",
    "BROWSE.FILTERS.SESSION_STATUS.AWAITING_UPLOAD": "En attente de chargement",
    "BROWSE.FILTERS.SESSION_STATUS.COMPLETED": "Complété",
    "BROWSE.FILTERS.SESSION_STATUS.DELETED": "Supprimé",
    "BROWSE.FILTERS.SESSION_STATUS.IN_PROGRESS": "En cours",
    "BROWSE.FILTERS.SESSION_TYPE.CONTINUOUS": "Continu",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION": "Corrélation",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_1_MIN_DELAY": "Corrélation : délai d'une minute",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_12_MIN_DELAY": "Corrélation : délai de 12 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_15_MIN_DELAY": "Corrélation : délai de 15 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_5_MIN_DELAY": "Corrélation : délai de 5 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_8_MIN_DELAY": "Corrélation : délai de 8 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_CHILD": "Corrélation Enfant",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_PARENT": "Corrélation parent",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_DAY": "FCC : 3 minutes par jour",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_NIGHT": "FCC : 3 minutes de nuit",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_DAY": "FCC : 5 minutes par jour",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_NIGHT": "FCC : 5 minutes de nuit",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_DAY": "FCC : journée de 8 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_NIGHT": "FCC : 8 minutes de nuit",
    "BROWSE.FILTERS.SESSION_TYPE.FIVE_MINUTES": "5 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.ONE_HOUR": "1 heure",
    "BROWSE.FILTERS.SESSION_TYPE.OVERNIGHT": "Du jour au lendemain",
    "BROWSE.FILTERS.SESSION_TYPE.RELAY": "Relais",
    "BROWSE.FILTERS.SESSION_TYPE.SYSTEM_MODE": "Mode système",
    "BROWSE.FILTERS.SESSION_TYPE.TEST": "Test",
    "BROWSE.FILTERS.SESSION_TYPE.THIRTY_MINUTES": "30 minutes",
    "BROWSE.FILTERS.SESSION_TYPE.TWENTY_FOUR_HOURS": "24 heures",
    "BROWSE.FILTERS.SESSION_TYPE.TYPE": "Taper",
    "BROWSE.FILTERS.SESSION_TYPES": "Types de session",
    "BROWSE.FILTERS.SESSION_TYPES_PLACEHOLDER": "Sélectionner les types de session",
    "BROWSE.FILTERS.SESSIONS": "Séances",
    "BROWSE.FILTERS.SORTING": "Tri",
    "BROWSE.FILTERS.STATUS": "Statut",
    "BROWSE.FILTERS.STATUS_PLACEHOLDER": "Sélectionner les statuts",
    "BROWSE.FILTERS.STATUS.MAINTENANCE_ALERT": "Alerte de maintenance",
    "BROWSE.FILTERS.STATUS.OFFLINE": "Hors ligne",
    "BROWSE.FILTERS.STATUS.OK": "D'ACCORD",
    "BROWSE.FILTERS.STATUS.ONLINE": "En ligne",
    "BROWSE.FILTERS.STATUS.WARNING": "Avertissement",
    "BROWSE.FILTERS.TO": "À",
    "BROWSE.FILTERS.TYPES": "Types",
    "BROWSE.FILTERS.TYPES_PLACEHOLDER": "Sélectionner les types de session",
    "BROWSE.FILTERS.WAYPOINTS": "Points de passage",
    "BROWSE.LABELS.TYPE": "Taper",
    "BROWSE.LAYOUT.LOADING_MAP": "Chargement de la carte",
    "BROWSE.LAYOUT.LOADING_MAP_DESCRIPTION": "Veuillez patienter pendant l'initialisation de la carte interactive...",
    "BROWSE.LAYOUT.LOADING_PREVIEW": "Chargement de l'aperçu",
    "BROWSE.LAYOUT.LOADING_PREVIEW_DESCRIPTION": "Veuillez patienter pendant le chargement de votre aperçu partagé...",
    "BROWSE.LIST.BACK_TO_LIST": "Retour à la liste",
    "BROWSE.LIST.JOBS_VIEW_ACTIVE": "Offres d'emploi disponibles",
    "BROWSE.LIST.JOBS_VIEW_DESCRIPTION": "Les données relatives à l'emploi sont affichées sur la carte.",
    "BROWSE.PANEL.COLLAPSE": "Réduire le panneau",
    "BROWSE.PANEL.EXPAND": "Développer le panneau",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_FOUND_LAST_7_DAYS": "Des fuites ont été détectées au cours des 7 derniers jours.",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_MARKED_UP_LAST_7_DAYS": "Les fuites ont augmenté ces 7 derniers jours",
    "BROWSE.PREDEFINED_VIEWS.RELAY_NEEDS_MAINTENANCE": "Relais nécessitant une maintenance",
    "BROWSE.PREDEFINED_VIEWS.RELAY_WARNINGS_LAST_7_DAYS": "Alertes relayées au cours des 7 derniers jours",
    "BROWSE.PREVIEW.CHANGE_WAYPOINT": "changer de point de passage",
    "BROWSE.SHARE.ADD_EMAIL": "Ajouter un e-mail",
    "BROWSE.SHARE.ADD_MESSAGE": "Ajouter un message",
    "BROWSE.SHARE.COPY_LINK": "Copier le lien",
    "BROWSE.SHARE.ERROR.COPY_CLIPBOARD_FAILED": "Impossible de copier le lien dans le presse-papiers.",
    "BROWSE.SHARE.ERROR.GENERATE_LINK_FAILED": "Impossible de générer le lien de partage",
    "BROWSE.SHARE.REMOVE_EMAIL": "Retirer %1$s",
    "BROWSE.SHARE.SEND": "Envoyer",
    "BROWSE.SHARE.SUCCESS.EMAIL_SENT_AND_LINK_COPIED": "Courriel envoyé et lien copié dans le presse-papiers !",
    "BROWSE.SHARE.SUCCESS.LINK_COPIED": "Lien copié dans le presse-papiers !",
    "BROWSE.TABLE.COLUMNS.ADDRESS": "Adresse",
    "BROWSE.TABLE.COLUMNS.ASSET": "Actif",
    "BROWSE.TABLE.COLUMNS.BATTERY_VOLTAGE": "Tension de la batterie",
    "BROWSE.TABLE.COLUMNS.COLLECTED_BY": "Collecté par",
    "BROWSE.TABLE.COLUMNS.COMMENT": "Commentaire",
    "BROWSE.TABLE.COLUMNS.COMPANY": "Entreprise",
    "BROWSE.TABLE.COLUMNS.COMPANY_NAME": "Nom de l'entreprise",
    "BROWSE.TABLE.COLUMNS.CREATED_AT": "Créé à",
    "BROWSE.TABLE.COLUMNS.CREATED_DATE": "Date de création",
    "BROWSE.TABLE.COLUMNS.DEPLOYED_BY": "Déployé par",
    "BROWSE.TABLE.COLUMNS.DMA": "DMA",
    "BROWSE.TABLE.COLUMNS.END_DATE": "Date de fin",
    "BROWSE.TABLE.COLUMNS.END_TIME": "Fin des temps",
    "BROWSE.TABLE.COLUMNS.ENVIRONMENTAL_NOTES": "Notes environnementales",
    "BROWSE.TABLE.COLUMNS.EST_SIZE_ENG": "Taille estimée (en anglais)",
    "BROWSE.TABLE.COLUMNS.EXPECTED_FINISH": "Résultat prévu",
    "BROWSE.TABLE.COLUMNS.FIRMWARE": "Micrologiciel",
    "BROWSE.TABLE.COLUMNS.FLOW_REDUCTION": "Réduction du débit",
    "BROWSE.TABLE.COLUMNS.ID": "IDENTIFIANT",
    "BROWSE.TABLE.COLUMNS.JOB_COUNT": "Nombre d'emplois",
    "BROWSE.TABLE.COLUMNS.JOB_TYPE_CODE": "Code de type d'emploi",
    "BROWSE.TABLE.COLUMNS.JOBS": "Emplois",
    "BROWSE.TABLE.COLUMNS.LAST_ACTION_BY": "Dernière action par",
    "BROWSE.TABLE.COLUMNS.LAST_CONTACT": "Dernier contact",
    "BROWSE.TABLE.COLUMNS.LAST_SCHEDULED_ENGINEER": "Dernier ingénieur programmé",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATE": "Dernière mise à jour",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATED": "Dernière mise à jour",
    "BROWSE.TABLE.COLUMNS.LATITUDE": "Latitude",
    "BROWSE.TABLE.COLUMNS.LEAK_RESULT": "Résultat de la fuite",
    "BROWSE.TABLE.COLUMNS.LEAK_SIZE": "Taille de la fuite",
    "BROWSE.TABLE.COLUMNS.LONGITUDE": "Longitude",
    "BROWSE.TABLE.COLUMNS.MAC_ADDRESS": "Adresse MAC",
    "BROWSE.TABLE.COLUMNS.NAME": "Nom",
    "BROWSE.TABLE.COLUMNS.PARTNER": "Partenaire",
    "BROWSE.TABLE.COLUMNS.PARTNER_NAME": "Nom du partenaire",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER": "Diamètre du tuyau",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER_UNITS": "Unités de diamètre de tuyau",
    "BROWSE.TABLE.COLUMNS.PIPE_MATERIAL": "Matériau des tuyaux",
    "BROWSE.TABLE.COLUMNS.PREDICTED_LEAK_TYPE": "Type de fuite prévu",
    "BROWSE.TABLE.COLUMNS.PREDICTED_SIZE": "Taille prévue",
    "BROWSE.TABLE.COLUMNS.PROJECT": "Projet",
    "BROWSE.TABLE.COLUMNS.RELAY_CONNECTED": "Relais connecté",
    "BROWSE.TABLE.COLUMNS.RELAY_ID": "ID du relais",
    "BROWSE.TABLE.COLUMNS.RELAY_NAME": "Nom du relais",
    "BROWSE.TABLE.COLUMNS.SENSOR_ID": "ID du capteur",
    "BROWSE.TABLE.COLUMNS.SENSOR_MAC": "MAC du capteur",
    "BROWSE.TABLE.COLUMNS.SENSOR_NAME": "Nom du capteur",
    "BROWSE.TABLE.COLUMNS.SESSION": "Session",
    "BROWSE.TABLE.COLUMNS.SESSION_COUNT": "Nombre de sessions",
    "BROWSE.TABLE.COLUMNS.SESSION_ID": "ID de session",
    "BROWSE.TABLE.COLUMNS.SESSION_TYPE": "Type de session",
    "BROWSE.TABLE.COLUMNS.SESSIONS": "Séances",
    "BROWSE.TABLE.COLUMNS.SIZE": "Taille",
    "BROWSE.TABLE.COLUMNS.START_DATE": "Date de début",
    "BROWSE.TABLE.COLUMNS.START_TIME": "Heure de début",
    "BROWSE.TABLE.COLUMNS.STATUS": "Statut",
    "BROWSE.TABLE.COLUMNS.SURFACE_TYPE": "Type de surface",
    "BROWSE.TABLE.COLUMNS.UPDATE_DATE": "Date de mise à jour",
    "BROWSE.TABLE.COLUMNS.WAYPOINT_NAME": "Nom du point de passage",
    "BROWSE.TABLE.COLUMNS.WHAT3WORDS": "What3Words",
    "BROWSE.TABLE.ID_PREFIX": "IDENTIFIANT:",
    "BROWSE.TABLE.SORT_BY": "Trier par %1$s",
    "BROWSE.TABS.RELAYS": "Relais",
    "BROWSE.TABS.SENSORS": "Capteurs",
    "BROWSE.TABS.SESSIONS": "Séances",
    "BROWSE.TABS.WAYPOINTS": "Points de passage",
    "BROWSE.VIEWS.CREATED_SUCCESS": "Vue personnalisée créée avec succès",
    "BROWSE.VIEWS.DELETE_CONFIRM": "Supprimer la vue enregistrée ?",
    "BROWSE.VIEWS.DELETE_DESCRIPTION": "Cela supprimera définitivement \"%1$s\".",
    "BROWSE.VIEWS.EMPTY": "Aucune vue enregistrée pour le moment",
    "BROWSE.VIEWS.LOAD_ERROR": "Impossible de charger les vues",
    "BROWSE.VIEWS.LOADING": "Chargement des vues...",
    "BROWSE.VIEWS.POPOVER_DESCRIPTION": "Vous pouvez enregistrer vos filtres favoris et y accéder en un seul clic depuis ici.",
    "BROWSE.VIEWS.SAVE_BUTTON": "Enregistrer la vue",
    "BROWSE.VIEWS.SAVE_DESCRIPTION": "Donnez un nom à votre vue personnalisée pour enregistrer vos filtres actuels.",
    "BROWSE.VIEWS.SAVE_TITLE": "Enregistrer la vue personnalisée",
    "BROWSE.VIEWS.VIEW_NAME_LABEL": "Nom de la vue",
    "BROWSE.VIEWS.VIEW_NAME_PLACEHOLDER": "Saisissez le nom de la vue",
    "BROWSE.VIEWS.YOUR_SAVED_VIEWS": "Vos vues enregistrées",
    "BROWSE.VIEWS.YOUR_VIEWS_SHORT": "Vos opinions",
    "CHANGE_LOG.ACTIONS.CREATE_BRANCH": "Créer un projet",
    "CHANGE_LOG.ACTIONS.CREATE_COMPANY": "Créer une entreprise",
    "CHANGE_LOG.ACTIONS.CREATE_USER": "Créer une invitation pour un utilisateur",
    "CHANGE_LOG.ACTIONS.DELETE_BRANCH": "Supprimer un projet",
    "CHANGE_LOG.ACTIONS.DELETE_COMPANY": "Supprimer l'entreprise",
    "CHANGE_LOG.ACTIONS.DELETE_USER": "Supprimer un utilisateur",
    "CHANGE_LOG.ACTIONS.EDIT_COMPANY": "Société d'édition",
    "CHANGE_LOG.ACTIONS.FORGOT_PASSWORD": "Envoyer un courriel avec le lien de récupération",
    "CHANGE_LOG.ACTIONS.GET_COMPANY": "Obtenir une société",
    "CHANGE_LOG.ACTIONS.LOGIN": "Connexion",
    "CHANGE_LOG.ACTIONS.SET_PASSWORD": "Définir le mot de passe du profil",
    "CHANGE_LOG.ACTIONS.TOKEN_DECODE": "Décoder le jeton d'adresse électronique",
    "CHANGE_LOG.ACTIONS.UPDATE_BRANCH": "Le projet a été mis à jour",
    "CHANGE_LOG.ACTIONS.UPDATE_USER": "Le profil de l'utilisateur a été mis à jour",
    "CHANGE_LOG.FILTERS.ACTION.LABEL": "Action",
    "CHANGE_LOG.FILTERS.ACTION.PLACEHOLDER": "Sélectionner une action",
    "CHANGE_LOG.FILTERS.BRANCH.LABEL": "Projet",
    "CHANGE_LOG.FILTERS.BRANCH.PLACEHOLDER": "Sélectionner un projet",
    "CHANGE_LOG.FILTERS.CLEAR": "Rejeter",
    "CHANGE_LOG.FILTERS.COMPANY.LABEL": "Entreprise",
    "CHANGE_LOG.FILTERS.COMPANY.PLACEHOLDER": "Sélectionner une entreprise",
    "CHANGE_LOG.FILTERS.DATE.LABEL": "Date",
    "CHANGE_LOG.FILTERS.DATE.PLACEHOLDER": "Sélectionnez une date",
    "CHANGE_LOG.FILTERS.EMAIL.LABEL": "Courriel",
    "CHANGE_LOG.FILTERS.EMAIL.PLACEHOLDER": "Saisir un courriel",
    "CHANGE_LOG.FILTERS.ERASE": "Clair",
    "CHANGE_LOG.FILTERS.STATUS.LABEL": "Statut",
    "CHANGE_LOG.FILTERS.STATUS.PLACEHOLDER": "Sélectionner un statut",
    "CHANGE_LOG.FILTERS.SUBMIT": "Filtre",
    "CHANGE_LOG.FILTERS.TITLE": "Filtres",
    "CHANGE_LOG.STATUSES.FAILURE": "Échec",
    "CHANGE_LOG.STATUSES.SUCCESS": "Succès",
    "CHANGE_LOG.TABLE.ACTION": "Action",
    "CHANGE_LOG.TABLE.BRANCH": "Projet",
    "CHANGE_LOG.TABLE.COMPANY": "Entreprise",
    "CHANGE_LOG.TABLE.DATE": "Date",
    "CHANGE_LOG.TABLE.EMAIL": "Courriel",
    "CHANGE_LOG.TABLE.NAME": "Nom",
    "CHANGE_LOG.TABLE.NUMBER": "№",
    "CHANGE_LOG.TABLE.ROLE": "Rôle",
    "CHANGE_LOG.TABLE.STATUS": "Statut",
    "CHANGE_LOG.TABLE.TIME": "L'heure",
    "CHANGE_LOG.TITLE.NO_LOGS": "Il n'y a pas de registre",
    "CHANGE_LOG.TITLE.TOTAL_COUNT": "Nombre total de journaux :",
    "CHATBOT.DEFAULT_ASSISTANT_MSG": "Comment puis-je vous aider ?",
    "CHATBOT.INPUT.PLACEHOLDER": "Rédiger un message",
    "CHATBOT.OFFLINE_MSG": "askFIDO est actuellement indisponible. Veuillez réessayer plus tard.",
    "CHATBOT.RATING.RESPONSE": "Merci pour le retour d'information",
    "CHATBOT.SUBHEADING": "En ligne",
    "CHATBOT.SUBHEADING_ERROR": "Hors ligne",
    "CHATBOT.YOU": "Vous",
    "COMMON.ACTION.CANCEL": "Annuler",
    "COMMON.ACTION.CLEAR": "Clair",
    "COMMON.ACTION.CLEAR_SEARCH": "Recherche propre",
    "COMMON.ACTION.CLOSE": "Fermer",
    "COMMON.ACTION.COPY_COORDINATES": "Copier les coordonnées",
    "COMMON.ACTION.COPY_COORDINATES_TO_CLIPBOARD": "Copier les coordonnées dans le presse-papiers",
    "COMMON.ACTION.DELETE": "Supprimer",
    "COMMON.ACTION.LOAD_MORE": "Charger plus",
    "COMMON.ACTION.RESET": "Réinitialiser",
    "COMMON.ACTION.SAVING": "Économie...",
    "COMMON.ACTION.SEARCH": "Recherche",
    "COMMON.ACTION.SHARE": "Partager",
    "COMMON.BOOLEAN.NO": "Non",
    "COMMON.BOOLEAN.YES": "Oui",
    "COMMON.BUTTON.EDIT": "modifier",
    "COMMON.BUTTON.OPEN": "ouvrir",
    "COMMON.BUTTON.SHARE": "partager",
    "COMMON.DATE.PLACEHOLDER.DDMMYYYY": "jj/mm/aaaa",
    "COMMON.EMPTY.ADJUST_FILTERS_OR_SEARCH": "Essayez de modifier vos filtres ou vos critères de recherche.",
    "COMMON.EMPTY.ADJUST_SEARCH_TERMS": "Essayez de modifier vos termes de recherche ou vérifiez les fautes de frappe.",
    "COMMON.EMPTY.NO_DATA": "Aucune donnée.",
    "COMMON.EMPTY.NO_RESULTS_FOUND": "Aucun résultat trouvé",
    "COMMON.ERROR.FAILED_TO_LOAD_DATA": "Échec du chargement des données",
    "COMMON.ERROR.GENERIC_TRY_AGAIN_LATER": "Une erreur s'est produite lors de la récupération des données. Veuillez réessayer plus tard.",
    "COMMON.ERROR.SUGGESTIONS_FETCH": "Une erreur s'est produite lors de la récupération des suggestions. Veuillez réessayer plus tard.",
    "COMMON.FILTERS.APPLY_FILTERS": "Appliquer les filtres",
    "COMMON.FILTERS.EMAILS_PLACEHOLDER": "Filtrer les courriels...",
    "COMMON.FILTERS.SAVE_FILTERS": "Enregistrer les filtres",
    "COMMON.FILTERS.TOGGLE_FILTERS": "activer/désactiver les filtres",
    "COMMON.FORM.PLACEHOLDER.ZERO": "0",
    "COMMON.LOADING.GENERIC": "Chargement...",
    "COMMON.LOADING.SUGGESTIONS": "Chargement des suggestions...",
    "COMMON.MEDIA.PAUSE_VIDEO": "Mettre la vidéo en pause",
    "COMMON.MEDIA.PLAY_AUDIO": "Lire l'audio",
    "COMMON.MEDIA.PLAY_VIDEO": "Lire la vidéo",
    "COMMON.MEDIA.UPLOAD_ALT": "Médias téléchargés",
    "COMMON.MEDIA.VIDEO_LOAD_ERROR": "Une erreur s'est produite lors du chargement de la vidéo. Veuillez réessayer plus tard.",
    "COMMON.PAGINATION.NEXT_PAGE": "Passer à la page suivante",
    "COMMON.PAGINATION.OF": "de",
    "COMMON.PAGINATION.PAGE_TITLE": "Page %1$s",
    "COMMON.PAGINATION.PREVIOUS_PAGE": "Aller à la page précédente",
    "COMMON.PAGINATION.ROWS_PER_PAGE": "Lignes par page",
    "COMMON.SEARCH.RESULTS": "Résultats",
    "COMMON.SEARCH.SUGGESTIONS": "Suggestions",
    "COMMON.SEARCH.WAITING_FOR_TYPING": "J'attends que vous ayez fini de taper...",
    "COMMON.SORT.ASC": "Ascendant",
    "COMMON.SORT.DESC": "Descendant",
    "COMMON.TABLE.COLUMNS_SETTINGS": "Paramètres des colonnes",
    "COMMON.TABLE.CUSTOMIZE_TABLE": "Personnaliser la table",
    "COMMON.TABLE.CUSTOMIZE_TABLE_DESCRIPTION": "Réorganiser, épingler et afficher/masquer les colonnes",
    "COMMON.TABLE.DRAG_TO_PIN": "Faites glisser les colonnes ici pour les épingler.",
    "COMMON.TABLE.DRAG_TO_REORDER": "Faites glisser pour réorganiser",
    "COMMON.TABLE.DRAG_TO_UNPIN": "Faites glisser les colonnes ici pour les détacher.",
    "COMMON.TABLE.MANAGE_COLUMNS": "Gérer les colonnes",
    "COMMON.TABLE.MAX_PINNED_COLUMNS_REACHED": "Nombre maximal de colonnes fixées atteint",
    "COMMON.TABLE.OTHER_COLUMNS": "Autres rubriques",
    "COMMON.TABLE.PIN_COLUMN": "Colonne à broches",
    "COMMON.TABLE.PINNED_COLUMNS": "Colonnes épinglées",
    "COMMON.TABLE.PINNED_COLUMNS_COUNT": "Colonnes épinglées (%1$s/%1$s)",
    "COMMON.TABLE.UNPIN_COLUMN": "Colonne décrochée",
    "COMMON.UPLOAD.CHOOSE_FILE": "Choisir un fichier",
    "COMMON.VALIDATION.INVALID_EMAIL": "Adresse e-mail invalide",
    "COMMON.VIEW.CLASSIC_VIEW": "Vue classique",
    "COMMON.VIEW.LIST_VIEW": "Vue liste",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.COMPANIES": "Entreprises",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.DEFAULT_TITLE": "Sélectionner un partenaire ou une entreprise",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.PARTNERS": "Partenaires",
    "COMPANIES_PAGE.ADD_COMPANY.BUTTON": "Nouvelle entreprise",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.LABEL": "Adresse de l'entreprise",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.PLACEHOLDER": "Saisir l'adresse",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.LABEL": "Nom de l'entreprise",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.PLACEHOLDER": "Saisir le nom",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.SUBMIT": "Ajouter",
    "COMPANIES_PAGE.ADD_COMPANY.TITLE": "Ajouter une nouvelle entreprise",
    "COMPANIES_PAGE.CRUMB": "Entreprises",
    "COMPANIES_PAGE.DELETE_COMPANY.TITLE": "Êtes-vous sûr de vouloir supprimer cette entreprise ?",
    "COMPANIES_PAGE.SUBTITLE": "D'autres informations importantes sont disponibles ici",
    "COMPANIES_PAGE.TABLE.ACTIONS": "Actions",
    "COMPANIES_PAGE.TABLE.ADDRESS": "Adresse",
    "COMPANIES_PAGE.TABLE.BRANCHES": "Projets",
    "COMPANIES_PAGE.TABLE.ID": "ID",
    "COMPANIES_PAGE.TABLE.INDEX": "№",
    "COMPANIES_PAGE.TABLE.NAME": "Nom",
    "COMPANIES_PAGE.TABLE.REPORTS": "Total des rapports personnalisés",
    "COMPANIES_PAGE.TABLE.USERS": "Total des utilisateurs",
    "COMPANIES_PAGE.TITLE.NO_COMPANIES": "Il n'y a pas d'entreprises",
    "COMPANIES_PAGE.TITLE.TOTAL_COUNT": "Total des entreprises :",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ALLOCATE_LE": "Attribuer LE",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_ERROR": "Erreur, veuillez réessayer",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_SUCCESS": "Succès, les points de passage ont été attribués",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ASSIGN_WAYPOINTS": "Affecter des points de passage sélectionnés à l'ingénieur chargé des fuites",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CHANGE": "Changer",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CLOSE": "Fermer",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.NO_WAYPOINTS": "Aucun point de passage n'est sélectionné",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.OPTION_ENGINEER": "Ingénieur :",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.REMOVE": "supprimer",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SEARCH.PLACEHOLDER": "Recherche d'un ingénieur",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SELECTING_ERROR": "Veuillez sélectionner un ingénieur et des points de passage",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SUBMIT_BTN": "Attribuer des points de passage",
    "COMPONENTS.COMPANY_SELECT.CHOOSE_COMPANY": "Choisir une entreprise/un partenaire",
    "COMPONENTS.COMPANY_SELECT.COMPANY": "Projet",
    "COMPONENTS.COMPANY_SELECT.ERROR": "Oups ! Un problème s'est produit. Veuillez rafraîchir la page et réessayer.",
    "COMPONENTS.COMPANY_SELECT.FORM.SEARCH.PLACEHOLDER": "Rechercher une entreprise, un partenaire ou un projet",
    "COMPONENTS.COMPANY_SELECT.FORM.SELECT.PLACEHOLDER": "Sélectionnez le type de données",
    "COMPONENTS.COMPANY_SELECT.NO_DATA": "Il n'y a pas de projet disponible",
    "COMPONENTS.COMPANY_SELECT.NO_RESULTS": "Aucun résultat trouvé",
    "COMPONENTS.COMPANY_SELECT.PARTNER": "Entreprise/Partenaire",
    "COMPONENTS.COMPANY_SELECT.VIEW": "Voir",
    "COMPONENTS.DATE_VIEWER.END_DATE": "Date de fin",
    "COMPONENTS.DATE_VIEWER.START_DATE": "Date de début",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.COMPANIES": "Entreprises",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.ENGINEERS": "Ingénieurs",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PARTNERS": "Partenaires",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PROJECTS": "Projets",
    "COMPONENTS.ERROR_BOUNDARY.MESSAGE": "Une erreur inattendue s'est produite.",
    "COMPONENTS.ERROR_BOUNDARY.RELOAD": "Recharger la page",
    "COMPONENTS.ERROR_BOUNDARY.SHOW_STACK": "Afficher la pile d'erreurs (Développement)",
    "COMPONENTS.ERROR_BOUNDARY.TITLE": "Oups ! Il y a eu un problème.",
    "COMPONENTS.FILE_UPLOAD.BROWSE": "Parcourir le fichier",
    "COMPONENTS.FILE_UPLOAD.DRAG_TEXT": "Glisser-déposer",
    "COMPONENTS.FILE_UPLOAD.ERROR": "Le fichier est requis",
    "COMPONENTS.FILE_UPLOAD.FILES": "Dossiers",
    "COMPONENTS.FILE_UPLOAD.OR": "Ou",
    "COMPONENTS.FILE_UPLOAD.SUPPORTED": "Soutient : ",
    "COMPONENTS.FILTER.CLOSE": "Fermer",
    "COMPONENTS.FILTER.SELECT_A_DMA": "Sélectionner un DMA",
    "COMPONENTS.FILTER.SELECT_A_PROJECT": "Sélectionner un projet",
    "COMPONENTS.FILTER.SELECT_A_SIZE": "Sélectionnez une taille",
    "COMPONENTS.FILTER.SELECT_A_STATUS": "Sélectionner un statut",
    "COMPONENTS.FILTER.SELECT_DMA": "Sélectionner DMA",
    "COMPONENTS.FILTER.SELECT_PROJECT": "Sélectionner un projet",
    "COMPONENTS.FILTER.SELECT_SIZE": "Choisir la taille",
    "COMPONENTS.FILTER.SELECT_STATUS": "Sélectionner le statut",
    "COMPONENTS.FUNNEL_CHART.ERROR_MSG": "Pas de données",
    "COMPONENTS.GRAPH_TOGGLE.SPECTRAL_PROFILE": "Profil spectral",
    "COMPONENTS.HISTORY_CONTAINER.ACTION": "Action",
    "COMPONENTS.HISTORY_CONTAINER.DATETIME": "Date et heure",
    "COMPONENTS.HISTORY_CONTAINER.ID": "ID",
    "COMPONENTS.HISTORY_CONTAINER.NOTES": "notes",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT": "point de référence",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT_ID": "ID du point de référence",
    "COMPONENTS.HISTORY_CONTAINER.SCHEDULED_DATE": "date prévue",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_CHANGED_FROM_ID": "statut modifié par rapport à l'id",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_NAME": "transformé en nom de statut",
    "COMPONENTS.HISTORY_CONTAINER.TIME_ELAPSED": "Temps écoulé",
    "COMPONENTS.HISTORY_CONTAINER.TITLE": "Historique des journaux de bord",
    "COMPONENTS.HISTORY_CONTAINER.USER_ID": "identifiant de l'utilisateur",
    "COMPONENTS.HISTORY_CONTAINER.USER_NAME": "Auteur de la modification",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_ID": "identifiant du point de passage",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_NAME": "nom du point de passage",
    "COMPONENTS.ICON_INSIGHT.ALT": "Icône d'information",
    "COMPONENTS.IMAGE_UPLOAD_BOX.BUTTON_TEXT": "Parcourir la photo",
    "COMPONENTS.IMAGE_UPLOAD_BOX.DRAG_TEXT": "Glisser-déposer",
    "COMPONENTS.IMAGE_UPLOAD_BOX.IMAGE_TYPE": "Prend en charge : *.png, *.jpg et *.jpeg",
    "COMPONENTS.IMAGE_UPLOAD_BOX.OR": "OU",
    "COMPONENTS.INSERT_DATE.ADD.END_DATE": "Ajouter la date de fin",
    "COMPONENTS.INSERT_DATE.ADD.START_DATE": "Ajouter la date de début",
    "COMPONENTS.INSERT_DATE.DATE.LABEL": "Date",
    "COMPONENTS.INSERT_DATE.DATE.PLACEHOLDER": "Sélectionner une date",
    "COMPONENTS.INSERT_DATE.EDIT.END_DATE": "Modifier la date de fin",
    "COMPONENTS.INSERT_DATE.EDIT.START_DATE": "Modifier la date de début",
    "COMPONENTS.INSERT_DATE.FAILURE_DESC": "Veuillez réessayer, la mise à jour n'a pas abouti.",
    "COMPONENTS.INSERT_DATE.FAILURE_TITLE": "Réessayez !",
    "COMPONENTS.INSERT_DATE.OK": "OK",
    "COMPONENTS.INSERT_DATE.SUBMIT": "Soumettre",
    "COMPONENTS.INSERT_DATE.SUCCESS_DESC": "La date a été mise à jour",
    "COMPONENTS.INSERT_DATE.SUCCESS_TITLE": "Génial !",
    "COMPONENTS.LEAK_SIZE_FUNNEL.LARGE": "Fuite importante",
    "COMPONENTS.LEAK_SIZE_FUNNEL.MEDIUM": "Fuite moyenne",
    "COMPONENTS.LEAK_SIZE_FUNNEL.SMALL": "Petite fuite",
    "COMPONENTS.PAGINATION.PAGE_OF": "{{page}} sur {{total}}",
    "COMPONENTS.PAGINATION.ROWS_PER_PAGE": "Lignes par page",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_DESC": "Veuillez réessayer le rapport n'a pas abouti.",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_TITLE": "Réessayez !",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.OK": "OK",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.POST_PROJECT_DESC": "Ce rapport vous sera envoyé par courrier électronique une fois que vous l'aurez soumis.",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SELECT_FORMAT": "Sélectionner le format",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_DESC": "Votre rapport a été créé. Vérifiez votre e-mail pour plus de détails.",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_TITLE": "Génial !",
    "COMPONENTS.PROGRESS_BAR.END_DATE": "Date de fin",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_A": "Déploiement du pipeline",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_B": "Pipeline collecté",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_C": "Objectif Progrès",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_D": "Téléchargé sur FIDO AI",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_E": "Déployé",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_F": "Validé",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_G": "Marqué pour la réparation",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_H": "Identifié par FIDO AI",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_REDUCTION": "L'eau économisée à partir des fuites prévues, des fuites marquées pour réparation et des fuites validées, par rapport à l'objectif de réduction.",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_TITLE": "Réduction des fuites",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_COVERAGE": "Couverture de la canalisation Indique la fraction de la canalisation totale qui a été couverte, exprimée en pourcentage.",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_TITLE": "Couverture des pipelines",
    "COMPONENTS.PROGRESS_BAR.SESSIONS": "Sessions",
    "COMPONENTS.PROGRESS_BAR.START_DATE": "Date de début",
    "COMPONENTS.PROGRESS_BAR.TARGET_LEAKAGE.ERROR_MSG": "Indiquez votre objectif de réduction des fuites pour activer l'affichage de la progression.",
    "COMPONENTS.PROGRESS_BAR.TARGET_PIPELINE.ERROR_MSG": "Indiquez la distance cible pour la couverture du pipeline afin d'activer l'affichage de la progression.",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_RESULTS": "Résultats concernant la taille des fuites",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.LARGE": "important",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.MEDIUM": "moyen",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.SMALL": "petit",
    "COMPONENTS.PROPORTIONAL_BAR.NO_LEAKS": "Aucune fuite n'a été détectée.",
    "COMPONENTS.PROPORTIONAL_BAR.TITLE": "Pourcentage ou nombre de fuites",
    "COMPONENTS.SEARCH_BAR.GENERIC": "Recherche",
    "COMPONENTS.SEARCH_BAR.SEARCH_COMPANIES": "Recherche d'entreprises",
    "COMPONENTS.SEARCH_BAR.SEARCH_PROJECTS": "Recherche de projets",
    "COMPONENTS.SEARCH_BAR.SEARCH.DISABLED_TOOLTIP": "Veuillez sélectionner un partenaire ou une entreprise avant d'utiliser la recherche",
    "COMPONENTS.SEARCH.IMG.ALT": "Icône de recherche",
    "COMPONENTS.SELECT.DESELECT_ALL": "Désélectionner tout",
    "COMPONENTS.SELECT.SELECT_ALL": "Sélectionner tout",
    "COMPONENTS.SESSION_INFORMATION.CONFIRMED_LEAKS": "Fuites confirmées",
    "COMPONENTS.SESSION_INFORMATION.NAME": "Nom",
    "COMPONENTS.SESSION_INFORMATION.REGION": "Région",
    "COMPONENTS.SESSION_INFORMATION.TITLE": "Informations sur l'ID DMA",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CANCEL": "Annuler",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CONFIRM": "Confirmer",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_A": "Êtes-vous sûr de vouloir cette session ID",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_B": "à placer sur cette Asset Key",
    "COMPONENTS.SESSION_RELOCATION.SUCCESS.REQUEST": "Session déplacée avec succès",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.ERROR": "Icône d'erreur",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.SUCCESS": "Icône de réussite",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.WARNING": "Icône d'avertissement",
    "COMPONENTS.STATUS_MODAL.ICON.NEGATIVE.ALT": "Croix indiquant l'échec",
    "COMPONENTS.STATUS_MODAL.ICON.POSITIVE.ALT": "Coche indiquant le succès",
    "COMPONENTS.STATUS_MODAL.OK": "OK",
    "COMPONENTS.WAYPOINT_HEADINGS.CONSUMPTION_PROFILE": "Profil de consommation",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION": "Corrélation",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.CONTENT": "La liste des corrélations et des sessions correspondantes s'affiche dans le format suivant :\\n{ID corrélation} : {Session A ID} - {Session B ID}",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.TITLE": "Liste déroulante des corrélations",
    "COMPONENTS.WAYPOINT_HEADINGS.JOB": "Emplois",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.CONTENT": "Cette liste déroulante représente les identifiants de session avec leur statut correspondant et l'heure de la dernière mise à jour dans le format :\\n{Identification de la session} : {État} : {Dernière heure de mise à jour}",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.TITLE": "Liste déroulante de la session",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.ID": "ID de la session",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.LAST_UPDATE": "L'heure de la fin",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.STATUS": "Statut",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.TYPE": "Type",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSIONS": "Sessions",
    "COMPONENTS.WAYPOINT_HEADINGS.TOP_SOUND": "Top Sound",
    "COMPONENTS.WAYPOINT_HEADINGS.WAYPOINT_LINK": "Retourner au point de repère",
    "COMPONENTS.WAYPOINT_KEY.LARGEST": "Le plus grand point de passage",
    "COMPONENTS.WAYPOINT_KEY.LATEST": "Dernier point de repère",
    "COMPONENTS.WAYPOINT_TABLE.NUMBER_ROWS": "Lignes par page",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FIVE": "Date de mise à jour",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FOUR": "Nom de l'ingénieur",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_ONE": "Nom",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SEVEN": "Sélectionner un point de passage",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SIX": "Date de création",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_THREE": "Statut",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_TWO": "Taille",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.CORRELATION": "Corrélation",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.MARKED_UP": "Marqué au fer rouge",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.OVERNIGHT_SESSION": "Session de nuit",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIR_SCHEDULED": "Réparation prévue",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIRED": "Réparation",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.SCHEDULED": "Prévu",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TITLE": "Statut actuel",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TOP_SOUND": "Son de tête",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.VALIDATED": "Validé",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.LABEL": "Courriel",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.PLACEHOLDER": "Saisir l'adresse électronique",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.LABEL": "Mot de passe",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.PLACEHOLDER": "Saisir le mot de passe",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Répéter le mot de passe",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Répéter le mot de passe",
    "CONFIRM_ACCOUNT_PAGE.FORM.SUBMIT": "Confirmer",
    "CONFIRM_ACCOUNT_PAGE.SUBTITLE": "Confirmer le compte ci-dessous",
    "CONFIRM_ACCOUNT_PAGE.TITLE": "Confirmer le compte",
    "CONSUMPTION_PROFILE_PAGE.CHART_LOAD_FAILED": "Impossible de charger les données du graphique de consommation. Veuillez actualiser la page ou contacter l'assistance si le problème persiste.",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_INFO_TITLE": "Informations sur la consommation",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_PROFILING": "ID de profilage de la consommation",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.DATE_TITLE": "Date Heure",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.END_TIME": "L'heure de la fin",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.EXPECTED_SAMPLES": "Échantillons attendus",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.START_TIME": "Heure de début",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.TITLE": "Informations sur le profil de consommation",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.UPLOADED_SAMPLES": "Échantillons téléchargés",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.EXPORT": "Exporter les données de la plage affichée",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.TITLE": "Profil de consommation",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COLLECTED_ENGINEER": "Ingénieur collectionneur",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COMPANY": "Entreprise",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.DEPLOYED_ENGINEER": "Ingénieur déployé",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LAST_UPDATED": "Jours depuis la dernière mise à jour",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LOCATION": "Localisation",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.POSTCODE": "Code postal",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.TITLE": "Données de localisation",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.WHAT3WORDS": "What3Words",
    "CONSUMPTION_PROFILE_PAGE.NO_DATA": "Il n'y a pas de données dans la plage affichée, veuillez essayer une autre plage.",
    "CORRELATION_GRAPHS.CORRELATION_IMG_ALT": "Image de corrélation",
    "CORRELATION_GRAPHS.NO_RESULTS": "Aucun son ou graphique n'est disponible pour la session Id :",
    "CORRELATION_GRAPHS.PAGE_TITLE": "Profil spectral",
    "CORRELATION_GRAPHS.PSD_IMG_ALT": "PSD pour la session",
    "CORRELATION_GRAPHS.SESSION_ID": "Id de la session",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.DETAILS_TITLE": "Détails de la corrélation",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.LEAK_DISTANCE": "Distance de fuite",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_A": "Emplacement du point A",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_B": "Emplacement du point B",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.SPEED_OF_SOUND": "Vitesse du son",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TIMESTAMP": "Horodatage",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TITLE": "Informations sur les corrélations",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TOTAL_LENGTH": "Longueur totale",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.COMPANY": "Entreprise",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.ENGINEER": "Ingénieur",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.TITLE": "Informations sur l'ingénieur",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.DIAMETER": "Diamètre",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.LENGTH": "Longueur",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.MILLIMETERS": "mm",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.TITLE": "Détails des matériaux",
    "CORRELATION_INFO_PAGE.STATUS.CENTRAL": "La position centrale est suspectée, veuillez vérifier manuellement",
    "CORRELATION_INFO_PAGE.STATUS.DETECTED": "La corrélation a été fructueuse",
    "CORRELATION_INFO_PAGE.STATUS.INCONCLUSIVE": "Corrélation non concluante",
    "CORRELATION_INFO_PAGE.STATUS.NOT_FOUND": "Corrélation non trouvée",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.DESCRIPTION": "Les résultats de la corrélation indiquent qu'il n'y a pas de fuite.",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.TITLE": "Excellente nouvelle !",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_A": "Informations suspectes sur le tuyau ou hors du cadre vers le point A",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_B": "Informations suspectes sur le tuyau ou hors du cadre vers le point B",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.DESCRIPTION": "Les résultats de la corrélation indiquent la présence d'une fuite.",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.TITLE": "Attention !",
    "CURRENCY.EUR": "L'euro",
    "CURRENCY.GBP": "Livre sterling",
    "CURRENCY.USD": "Dollar américain",
    "DASHBOARD_PAGE.CO2.LABEL": "Économies de CO2",
    "DASHBOARD_PAGE.LEAKS.LABEL": "Nombre de fuites",
    "DASHBOARD_PAGE.LEAKS.LEGEND.LARGE": "Grandes dimensions",
    "DASHBOARD_PAGE.LEAKS.LEGEND.MEDIUM": "Moyen",
    "DASHBOARD_PAGE.LEAKS.LEGEND.SMALL": "Petit",
    "DASHBOARD_PAGE.LEAKS.SUBTITLE": "Nombre de fuites détectées",
    "DASHBOARD_PAGE.LEAKS.TITLE": "Fuites Taille",
    "DASHBOARD_PAGE.SUBTITLE": "D'autres informations importantes sont disponibles ici",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.SUBTITLE": "Enjeux",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.TITLE": "Alertes d'exception",
    "DASHBOARD_PAGE.SUMMARY.FIDO_FUNNEL": "Entonnoir Fido",
    "DASHBOARD_PAGE.SUMMARY.FIDO_SCORE": "Score Fido",
    "DASHBOARD_PAGE.SUMMARY.LEAK_TITLE": "Informations sur les fuites",
    "DASHBOARD_PAGE.SUMMARY.LEAKS_IDENTIFIED": "Fuites prédites par l'IA FIDO",
    "DASHBOARD_PAGE.SUMMARY.LOCATE_DMA_BUTTON": "Localiser la DMA sur la carte",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_REPAIRED": "Nombre marqué pour réparation",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_SCHEDULED": "Nombre prévu",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_VERIFIED_REPAIRED": "Nombre de réparations vérifiées par FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.DELIVERY": "Performances en matière de livraison",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.HEALTH_CHECK": "Rapport sur le bilan de santé",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.POST_PROJECT": "Rapport post-projet",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.PROJECT": "État d'avancement du projet",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.TITLE": "Rapports",
    "DASHBOARD_PAGE.SUMMARY.SESSIONS_ANALISED": "Fichiers analysés par FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.COMPANY": "Chronologie de l'entreprise",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.PROJECT": "Calendrier du projet",
    "DASHBOARD_PAGE.TIME_RANGE.ALL_TIME": "Tout le temps",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_30_DAYS": "30 derniers jours",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_7_DAYS": "7 derniers jours",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_YEAR": "L'année dernière",
    "DASHBOARD_PAGE.TIME_RANGE.TODAY": "Aujourd'hui",
    "DASHBOARD_PAGE.TITLE": "Tableau de bord",
    "DASHBOARD_PAGE.TOTAL_LEAKAGE_DETECTED": "Fuite totale détectée",
    "DASHBOARD_PAGE.VIEW_ALL_BTN": "Voir tous les projets",
    "DASHBOARD_PAGE.VOLUMETRICS.SUBTITLE": "Volumétrie des fuites",
    "DASHBOARD_PAGE.WATER.ANALYSED_BY": "Sessions analysées par FIDO AI",
    "DASHBOARD_PAGE.WATER.COST": "Coût de l'eau perdue",
    "DASHBOARD_PAGE.WATER.COST_PER_YEAR": "USD par an",
    "DASHBOARD_PAGE.WATER.FIDO_AI": "FIDO AI",
    "DASHBOARD_PAGE.WELCOME": "Bienvenue",
    "DASHBOARD_PAGE.WELCOME_DESCRIPTION": "Ici, vous pouvez accéder à des données clés telles que la couverture, la réduction des fuites, le coût des pertes d'eau et le suivi des progrès.",
    "DELETE_USER.BTN.CANCEL": "Annuler",
    "DELETE_USER.BTN.CLOSE": "Fermer la fenêtre modale",
    "DELETE_USER.BTN.SUBMIT": "Supprimer",
    "DELETE_USER.DESC": "La suppression de ce profil entraîne la suppression de toutes les données personnelles.",
    "DELETE_USER.SUCCESS.MSG": "Utilisateur supprimé avec succès",
    "DELETE_USER.TITLE": "Supprimer le profil ?",
    "DELETE_USER.VALIDATION.ERROR": "L'utilisateur n'a pas pu être supprimé, veuillez réessayer",
    "DELIVERY_PERFORMANCE_PAGE.COLLECTIONS": "Collections",
    "DELIVERY_PERFORMANCE_PAGE.CONVERSION_RATE": "Taux de conversion",
    "DELIVERY_PERFORMANCE_PAGE.COVERED": "Distance parcourue",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENT_ACCURACY": "Précision du déploiement",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENTS": "Déploiements",
    "DELIVERY_PERFORMANCE_PAGE.END_DATE": "Date de fin",
    "DELIVERY_PERFORMANCE_PAGE.HOURS_WORKED": "Heures travaillées",
    "DELIVERY_PERFORMANCE_PAGE.IN_PROGRESS_WAYPOINTS": "Points de passage en cours",
    "DELIVERY_PERFORMANCE_PAGE.KM_COVERED": "km couverts",
    "DELIVERY_PERFORMANCE_PAGE.LEAKS_MARKED_UP": "Fuites marquées",
    "DELIVERY_PERFORMANCE_PAGE.NAME": "Nom",
    "DELIVERY_PERFORMANCE_PAGE.NON_LEAKS_MARKED_UP": "Non-fuites Marquage",
    "DELIVERY_PERFORMANCE_PAGE.NOT_FOUND_WAYPOINTS": "points de passage non trouvés",
    "DELIVERY_PERFORMANCE_PAGE.START_DATE": "date de début",
    "DELIVERY_PERFORMANCE_PAGE.WAYPOINTS_INVESTIGATED": "points de passage étudiés",
    "DETAIL_WIDGET.TITLE_A": "Sessions",
    "DETAIL_WIDGET.TITLE_B": "FIDO AI Volumétrique Identifié",
    "DETAIL_WIDGET.TITLE_C": "Coût de la perte d'eau au fil de l'eau",
    "DIALOG.CONFIRM_DELETE.DESCRIPTION": "Êtes-vous sûr de vouloir supprimer cette colonne ?",
    "DIALOG.CONFIRM_DELETE.TITLE": "Confirmer",
    "DIALOG.FORGOT_PASSWORD.CLOSE": "Fermer",
    "DIALOG.FORGOT_PASSWORD.DESCRIPTION": "Nous enverrons un lien de récupération de mot de passe à l'adresse e-mail de l'utilisateur.",
    "DIALOG.FORGOT_PASSWORD.SUBMIT": "Réinitialiser le mot de passe",
    "DIALOG.FORGOT_PASSWORD.TITLE": "Réinitialiser le mot de passe",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.BUTTON": "Nouveau projet",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.LABEL": "Nom du projet",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.PLACEHOLDER": "Saisir le nom du projet",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.SUBMIT": "Ajouter un projet",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.TITLE": "Ajouter un projet",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.BUTTON": "Nouvel employé",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.LABEL": "Projet",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.PLACEHOLDER": "Choisir un projet",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.LABEL": "Entreprise",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.PLACEHOLDER": "Choisir une entreprise",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.LABEL": "Adresse électronique",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.PLACEHOLDER": "Saisir l'adresse électronique",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.LABEL": "Prénom",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.PLACEHOLDER": "Saisir le prénom",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.LABEL": "Nom de famille",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.PLACEHOLDER": "Saisir le nom de famille",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.LABEL": "Rôle",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.PLACEHOLDER": "Choisir un rôle",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.SUBMIT": "Ajouter un employé",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.TITLE": "Ajouter un employé",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ACTIONS": "Actions",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADD": "Ajouter",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADDRESS": "Adresse",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.BRANCHES": "Projets ({{ count }})",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NAME": "Nom du projet",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NO_BRANCHES": "Pas de projets",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_REPORTS": "Total des rapports",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_USERS": "Total des utilisateurs",
    "EDIT_COMPANY_PAGE.CRUMB": "Gérer l'entreprise",
    "EDIT_COMPANY_PAGE.DELETE_BRANCH.TITLE": "Êtes-vous sûr de vouloir supprimer ce projet ?",
    "EDIT_COMPANY_PAGE.DELETE_COMPANY.TITLE": "Êtes-vous sûr de vouloir supprimer cette entreprise ?",
    "EDIT_COMPANY_PAGE.DELETE_EMPLOYEE.TITLE": "Êtes-vous sûr de vouloir supprimer cet employé ?",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.BUTTON": "Editer le projet",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.NAME.PLACEHOLDER": "Saisir le nom du projet",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.SUBMIT": "Projet de mise à jour",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.TITLE": "Editer le projet",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ACTIONS": "Actions",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ADD": "Ajouter",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.BRANCH": "Projet",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMAIL": "Courriel",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMPLOYEES": "Employés ({{ count }})",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NAME": "Nom de l'utilisateur",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NO_EMPLOYEES": "Aucun employé",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ROLE": "Rôle",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.STATUS": "Statut",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.TOTAL_REPORTS": "Total des rapports personnalisés",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.LABEL": "Adresse",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.PLACEHOLDER": "Saisir l'adresse",
    "EDIT_COMPANY_PAGE.FORM.DELETE": "Supprimer",
    "EDIT_COMPANY_PAGE.FORM.DISCARD": "Rejeter",
    "EDIT_COMPANY_PAGE.FORM.EDIT": "Editer",
    "EDIT_COMPANY_PAGE.FORM.NAME.LABEL": "Nom",
    "EDIT_COMPANY_PAGE.FORM.NAME.PLACEHOLDER": "Saisir le nom",
    "EDIT_COMPANY_PAGE.FORM.NO_CHANGES": "Pas de changement",
    "EDIT_COMPANY_PAGE.FORM.SUBMIT": "Économiser",
    "EDIT_COMPANY_PAGE.TITLE": "Société d'édition",
    "EDIT_PARTNER.COUNTRY": "Pays",
    "EDIT_PARTNER.PARTNER_CODE": "Code partenaire",
    "EDIT_PARTNER.PARTNER_NAME": "Nom du partenaire",
    "EDIT_PARTNER.TITLE": "Editer le partenaire",
    "EDIT_PROJECT.COMPANY.LABEL": "Entreprise",
    "EDIT_PROJECT.COMPANY.PLACEHOLDER": "Sélectionner une entreprise",
    "EDIT_PROJECT.COMPANY.VALIDATION": "Une entreprise est nécessaire",
    "EDIT_PROJECT.COST_PER_DISTANCE.LABEL": "Coût par distance",
    "EDIT_PROJECT.COST_PER_DISTANCE.PLACEHOLDER": "Coût par distance",
    "EDIT_PROJECT.COST_PER_DISTANCE.VALIDATION": "Le coût par distance est requis",
    "EDIT_PROJECT.DISCARD": "Rejeter",
    "EDIT_PROJECT.DMAS.LABEL": "DMA",
    "EDIT_PROJECT.DMAS.NO_MATCHING": "Pas de DMA correspondant",
    "EDIT_PROJECT.DMAS.PLACEHOLDER": "Sélectionner les DMA",
    "EDIT_PROJECT.END_DATE.LABEL": "Date de fin",
    "EDIT_PROJECT.END_DATE.PLACEHOLDER": "Sélectionner la date de fin",
    "EDIT_PROJECT.END_DATE.VALIDATION": "La date de fin doit être postérieure à la date de début",
    "EDIT_PROJECT.NAME.LABEL": "Nom du projet",
    "EDIT_PROJECT.NAME.PLACEHOLDER": "Saisir le nom du projet",
    "EDIT_PROJECT.NAME.VALIDATION": "Le nom du projet est obligatoire",
    "EDIT_PROJECT.NO_CHANGES": "Pas de changement dans les informations relatives au projet.",
    "EDIT_PROJECT.START_DATE.LABEL": "Date de début",
    "EDIT_PROJECT.START_DATE.PLACEHOLDER": "Sélectionner la date de début",
    "EDIT_PROJECT.START_DATE.VALIDATION": "La date de début doit être antérieure à la date de fin",
    "EDIT_PROJECT.SUBMIT": "Soumettre",
    "EDIT_PROJECT.TARGET_DISTANCE.LABEL": "Distance cible",
    "EDIT_PROJECT.TARGET_DISTANCE.PLACEHOLDER": "Entrez la distance cible",
    "EDIT_PROJECT.TARGET_DISTANCE.VALIDATION": "La distance cible est requise",
    "EDIT_PROJECT.TARGET_LEAKAGE.LABEL": "Fuite de la cible",
    "EDIT_PROJECT.TARGET_LEAKAGE.PLACEHOLDER": "Entrez la fuite cible",
    "EDIT_PROJECT.TARGET_LEAKAGE.VALIDATION": "Une fuite cible est requise",
    "EDIT_PROJECT.TITLE": "Editer le projet",
    "EDIT_USER.PAGE_TITLE": "Modifier l'utilisateur",
    "EDIT_USER.RETURN_BTN": "Rejeter",
    "EDIT_USER.SUBMIT_BTN": "Sauvegarder l'utilisateur",
    "ERROR.DUPLICATE_EMAIL": "L'adresse électronique saisie existe déjà",
    "ERROR.DUPLICATE_PROJECT": "Le nom du projet existe déjà",
    "ERROR.NO_DATA": "Les données relatives à cet utilisateur ne sont pas disponibles pour le moment.",
    "ERROR.REPORT.NO_DATA": "Le rapport n'a pas de données renvoyées. Veuillez essayer de modifier la plage de dates",
    "ERROR.REQUEST": "Une erreur s'est produite lors du traitement de votre demande. Veuillez essayer d'actualiser la page.",
    "ERROR.SESSION_EXPIRED": "La session a expiré, veuillez vous reconnecter",
    "EXPORT_BUTTON.ALL": "Exporter tout",
    "EXPORT_BUTTON.ALL_CSV": "Exporter tout (CSV)",
    "EXPORT_BUTTON.ALL_EXCEL": "Exporter tout (Excel)",
    "EXPORT_BUTTON.ALL_JSON": "Exporter tout (JSON)",
    "EXPORT_BUTTON.ERROR.REQUEST": "Erreur lors de l'exportation des données",
    "EXPORT_BUTTON.EXPORT": "Exporter",
    "EXPORT_BUTTON.FILTERED": "Exporter filtré",
    "EXPORT_BUTTON.FILTERED_CSV": "Exporter filtré (CSV)",
    "EXPORT_BUTTON.FILTERED_EXCEL": "Exporter filtré (Excel)",
    "EXPORT_BUTTON.FILTERED_JSON": "Exporter filtré (JSON)",
    "EXPORT_BUTTON.SUCCESS.REQUEST": "Vous devriez recevoir un e-mail avec l'exportation sous peu",
    "FILTERS.DATE_RANGE.TITLE": "Plage de dates",
    "FILTERS.DIALOG.SUBTITLE.CHANGE": "Tous les filtres seront supprimés ?",
    "FILTERS.DIALOG.SUBTITLE.CLOSE": "Les modifications seront supprimées",
    "FILTERS.DIALOG.TITLE.CHANGE": "Êtes-vous sûr de vouloir modifier la source de données ?",
    "FILTERS.DIALOG.TITLE.CLOSE": "Êtes-vous sûr de vouloir fermer les paramètres ?",
    "FILTERS.FORM.COLUMN.LABEL": "Colonne",
    "FILTERS.FORM.COLUMN.PLACEHOLDER": "Sélectionner une colonne",
    "FILTERS.FORM.SOURCE.LABEL": "Source des données",
    "FILTERS.FORM.SOURCE.PLACEHOLDER": "Sélectionner la source de données",
    "FILTERS.FORM.TYPE.LABEL": "Type",
    "FILTERS.FORM.TYPE.PLACEHOLDER": "Sélectionner le type",
    "FILTERS.FORM.VALUE.LABEL": "Valeur",
    "FILTERS.FORM.VALUE.PLACEHOLDER": "Sélectionner la valeur",
    "FILTERS.MODAL_TITLE": "Paramètres",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.LABEL": "Courriel",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Saisissez votre adresse électronique",
    "FORGOT_PASSWORD_PAGE.FORM.SUBMIT": "Envoyer le lien de réinitialisation",
    "FORGOT_PASSWORD_PAGE.RECOVERY_SUCCESS": "Le lien de récupération a été envoyé avec succès à votre adresse électronique",
    "FORGOT_PASSWORD_PAGE.SUBTITLE": "Saisissez votre adresse électronique ci-dessous",
    "FORGOT_PASSWORD_PAGE.TITLE": "Mot de passe oublié",
    "FORM.LABEL.COMPANY": "Entreprise",
    "FORM.LABEL.COUNTRY": "Pays",
    "FORM.LABEL.CURRENCY": "Devise",
    "FORM.LABEL.DIAMETER_UNIT": "Diamètre",
    "FORM.LABEL.EMAIL": "Courriel",
    "FORM.LABEL.FIRST_NAME": "Prénom",
    "FORM.LABEL.FLOW_RATE_UNIT": "Débit",
    "FORM.LABEL.LAST_NAME": "Nom de famille",
    "FORM.LABEL.LONG_DISTANCE_UNIT": "Longue distance",
    "FORM.LABEL.MEASUREMENT_SYSTEM": "Système de mesure",
    "FORM.LABEL.PARTNER": "Partenaire",
    "FORM.LABEL.PHONE": "Téléphone",
    "FORM.LABEL.ROLE": "Rôle",
    "FORM.LABEL.SHORT_DISTANCE_UNIT": "Courte distance",
    "FORM.LABEL.VOLUME_UNIT": "Volume",
    "FORM.LABEL.WEIGHT_UNIT": "Poids",
    "FORM.PLACEHOLDER.COMPANY": "Sélectionner une entreprise",
    "FORM.PLACEHOLDER.COUNTRY": "Sélectionner le pays",
    "FORM.PLACEHOLDER.CURRENCY": "Sélectionner la devise",
    "FORM.PLACEHOLDER.DIAMETER_UNIT": "Sélectionner le diamètre",
    "FORM.PLACEHOLDER.FLOW_RATE_UNIT": "Sélectionner le débit",
    "FORM.PLACEHOLDER.LONG_DISTANCE_UNIT": "Sélectionner longue distance",
    "FORM.PLACEHOLDER.MEASUREMENT_SYSTEM": "Sélectionner le système de mesure",
    "FORM.PLACEHOLDER.PARTNER": "Sélectionner un partenaire",
    "FORM.PLACEHOLDER.PHONE": "Sélectionner le téléphone",
    "FORM.PLACEHOLDER.ROLE": "Sélectionner un rôle",
    "FORM.PLACEHOLDER.SHORT_DISTANCE_UNIT": "Sélectionner courte distance",
    "FORM.PLACEHOLDER.VOLUME_UNIT": "Sélectionner le volume",
    "FORM.PLACEHOLDER.WEIGHT_UNIT": "Sélectionner le poids",
    "FORM.VALIDATION.COMPANY": "L'entreprise est tenue",
    "FORM.VALIDATION.COUNTRY": "Le pays est requis",
    "FORM.VALIDATION.CURRENCY": "La devise est requise",
    "FORM.VALIDATION.EMAIL": "L'adresse électronique est requise",
    "FORM.VALIDATION.FIRST_NAME": "Le prénom est obligatoire",
    "FORM.VALIDATION.LAST_NAME": "Le nom de famille est obligatoire",
    "FORM.VALIDATION.MEASUREMENT_SYSTEM": "Le système de mesure est requis",
    "FORM.VALIDATION.PARTNER": "Un partenaire est nécessaire",
    "FORM.VALIDATION.PHONE": "Le téléphone est requis",
    "FORM.VALIDATION.ROLE": "Le rôle est requis",
    "GIS_ADMIN.ACTION.SELECT": "Sélectionner",
    "GIS_ADMIN.DELETE_MODAL.BTN.CANCEL": "Annuler",
    "GIS_ADMIN.DELETE_MODAL.BTN.REMOVE": "Retirer",
    "GIS_ADMIN.DELETE_MODAL.ERROR_MSG": "Échec de la suppression du téléchargement SIG",
    "GIS_ADMIN.DELETE_MODAL.TITLE": "Confirmer la suppression de téléchargement SIG",
    "GIS_ADMIN.PREVIEW_MODAL.BTN.CLOSE": "Fermer l'aperçu",
    "GIS_ADMIN.PREVIEW_MODAL.ERROR_MSG": "Échec du chargement de l'aperçu",
    "GIS_ADMIN.PREVIEW_MODAL.NO_DATA": "Aucune donnée à afficher",
    "GIS_ADMIN.PREVIEW_MODAL.TITLE": "Aperçu SIG",
    "GIS_ADMIN.SEARCH.PLACEHOLDER": "Rechercher",
    "GIS_ADMIN.SEARCH.TEXT": "Rechercher",
    "GIS_ADMIN.TABLE.HEADERS.A": "Nom de l'entreprise",
    "GIS_ADMIN.TABLE.HEADERS.B": "Date de téléchargement",
    "GIS_ADMIN.TABLE.HEADERS.C": "Téléchargé par",
    "GIS_ADMIN.TABLE.HEADERS.D": "Action",
    "GIS_ADMIN.TABLE.TITLE": "Liste des téléchargements GIS",
    "GIS_ADMIN.TITLE": "Admin SIG",
    "GIS_UPLOAD.API.GENERIC_ERROR": "La demande a échoué, veuillez vérifier le format du fichier",
    "GIS_UPLOAD.ASSETS.COLUMN.CREATED_DATE.DESCRIPTION": "Date à laquelle l'actif a été installé",
    "GIS_UPLOAD.ASSETS.COLUMN.DIAMETER.DESCRIPTION": "Diamètre de l'actif",
    "GIS_UPLOAD.ASSETS.COLUMN.DMA_KEY.DESCRIPTION": "Référence à la clé de zone dont l'actif fait partie",
    "GIS_UPLOAD.ASSETS.COLUMN.KEY.DESCRIPTION": "Identifiant distinct pour chaque actif sur le réseau",
    "GIS_UPLOAD.ASSETS.COLUMN.SUBTYPE.DESCRIPTION": "Classification complémentaire détaillant les caractéristiques spécifiques de l'actif",
    "GIS_UPLOAD.ASSETS.COLUMN.TYPE.DESCRIPTION": "Classification de l'actif en fonction de sa fonction",
    "GIS_UPLOAD.BUTTON.DISCARD": "Rejeter",
    "GIS_UPLOAD.BUTTON.NEXT": "Suivant",
    "GIS_UPLOAD.DMA.COLUMN.KEY.DESCRIPTION": "Identifiant unique pour chaque zone",
    "GIS_UPLOAD.DMA.COLUMN.NAME.DESCRIPTION": "Nom descriptif de la zone",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_A": "affichage à l'écran du processus de mappage des colonnes",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_B": "affichage à l'écran du processus de cartographie des champs système",
    "GIS_UPLOAD.ERROR_MODAL.BUTTON.CLOSE": "Fermer",
    "GIS_UPLOAD.ERROR_MODAL.DESC.A": "Mappez les colonnes requises comme indiqué ci-dessous",
    "GIS_UPLOAD.ERROR_MODAL.DESC.B": "Mappez les champs système comme indiqué ci-dessous",
    "GIS_UPLOAD.ERROR_MODAL.DESC.C": "AUSSI",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.A": "Oups ! Un problème s'est produit de notre côté.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.B": "Il semble que notre système rencontre actuellement des problèmes. Veuillez réessayer plus tard.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.C": "Si le problème persiste, n'hésitez pas à contacter notre équipe d'assistance.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.D": "Une erreur s'est produite",
    "GIS_UPLOAD.ERROR.INVALID_FILE": "Fichier invalide",
    "GIS_UPLOAD.ERROR.MISSING_FILE": "Fichier manquant",
    "GIS_UPLOAD.FILE_HEADER.BTN.BACK_TO_PROJECT": "Retour à la création du projet",
    "GIS_UPLOAD.FILE_HEADER.BTN.CLOSE_MODAL": "Fermer la fenêtre modale",
    "GIS_UPLOAD.FILE_HEADER.BTN.GIS_ADMIN": "Voir GIS Admin",
    "GIS_UPLOAD.FILE_HEADER.BTN.LINK.GIS_ADMIN": "Afficher l'administrateur SIG",
    "GIS_UPLOAD.FILE_HEADER.BTN.UPLOAD": "Télécharger",
    "GIS_UPLOAD.FILE_HEADER.COUNTER": "Fichier",
    "GIS_UPLOAD.FILE_HEADER.DISCARD": "Fichier de rejet",
    "GIS_UPLOAD.FILE_HEADER.ERROR.PARAGRAPH": "Échec du téléchargement de GIS, veuillez réessayer",
    "GIS_UPLOAD.FILE_HEADER.FINAL_STEP": "Étape finale",
    "GIS_UPLOAD.FILE_HEADER.LOADING.TEXT": "Chargement",
    "GIS_UPLOAD.FILE_HEADER.MODAL.UPLOAD_TXT": "Chargement terminé ! Consultez la page d'administration pour les détails ci-dessous",
    "GIS_UPLOAD.FILE_HEADER.NEXT": "Suivant",
    "GIS_UPLOAD.FILE_HEADER.NO_FILE": "Aucun fichier à sélectionner",
    "GIS_UPLOAD.FILE_HEADER.PREVIOUS": "Précédent",
    "GIS_UPLOAD.FILE_HEADER.RESET": "Retour aux téléchargements de fichiers",
    "GIS_UPLOAD.FILE_HEADER.SUCCESS.PARAGRAPH": "SIG téléchargé avec succès",
    "GIS_UPLOAD.FILE_HEADER.TEXT.PARAGRAPH": "Êtes-vous sûr de vouloir télécharger le SIG ?",
    "GIS_UPLOAD.FILE_HEADER.TEXT.UPLOAD_PARAGRAPH": "Êtes-vous sûr de vouloir télécharger le SIG ?",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAP_PREVIEW": "Aperçu de la carte",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING": "Mappage des colonnes",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING_FOR": "pour",
    "GIS_UPLOAD.INPUT.COMPANY.LABEL": "Choisir une entreprise",
    "GIS_UPLOAD.INPUT.COMPANY.PLACEHOLDER": "Choisir une entreprise",
    "GIS_UPLOAD.LOADING": "Chargement...",
    "GIS_UPLOAD.MAP_PREVIEW.API.GENERAL_ERROR": "Erreur de chargement de la carte",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.GIS_ADMIN": "Voir GIS Admin",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.NEXT": "Suivant",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.PREVIOUS": "Précédent",
    "GIS_UPLOAD.MAP_PREVIEW.TITLE": "Aperçu de la carte",
    "GIS_UPLOAD.MAP_PREVIEW.UPLOAD_FINISHED": "Chargement terminé ! Consultez la page d'administration pour les détails ci-dessous",
    "GIS_UPLOAD.PAGE_TITLE": "Télécharger le SIG",
    "GIS_UPLOAD.PIPES.COLUMN.CREATED_DATE.DESCRIPTION": "Date à laquelle l'enregistrement du tuyau a été créé ou installé",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER_UNITS.DESCRIPTION": "Unités de mesure du diamètre du tuyau",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER.DESCRIPTION": "Diamètre du tuyau, unités spécifiées séparément",
    "GIS_UPLOAD.PIPES.COLUMN.DMA_KEY.DESCRIPTION": "Référence à la clé de zone dont le tuyau fait partie",
    "GIS_UPLOAD.PIPES.COLUMN.KEY.DESCRIPTION": "Identifiant distinct pour chaque tuyau du réseau",
    "GIS_UPLOAD.PIPES.COLUMN.MATERIAL.DESCRIPTION": "Matériau de construction principal du tuyau",
    "GIS_UPLOAD.PIPES.COLUMN.STATUS.DESCRIPTION": "Que le tuyau soit en service actif, abandonné, retiré, etc.",
    "GIS_UPLOAD.PIPES.COLUMN.SUBTYPE.DESCRIPTION": "Classification spécifique des tuyaux en fonction de leur fonction ou de leur structure",
    "GIS_UPLOAD.PIPES.COLUMN.TYPE.DESCRIPTION": "Quel service le tuyau effectue : distribution principale, ligne de service, conduite principale principale, etc.",
    "GIS_UPLOAD.ROUTES.STEP_FIVE": "Aperçu de la carte",
    "GIS_UPLOAD.ROUTES.STEP_FOUR": "Actifs du processus",
    "GIS_UPLOAD.ROUTES.STEP_ONE": "Télécharger le fichier Shapefile",
    "GIS_UPLOAD.ROUTES.STEP_THREE": "Tuyaux de traitement",
    "GIS_UPLOAD.ROUTES.STEP_TWO": "Processus DMA",
    "GIS_UPLOAD.STATUS.FILE_FETCHING": "Récupération des données du fichier...",
    "GIS_UPLOAD.STATUS.FILE_LOADING": "Chargement des données du fichier...",
    "GIS_UPLOAD.STATUS.FILE_UPLOADING": "Le fichier est en cours de chargement...",
    "GIS_UPLOAD.STATUS.LOADING_COMPANIES_DATA": "Chargement des données des entreprises...",
    "GIS_UPLOAD.STATUS.UPLOADING_FILE": "Téléchargement d'un fichier...",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN": "Créer une colonne",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN_ERROR": "Une erreur s'est produite : impossible de créer la colonne",
    "GIS_UPLOAD.TABLE.INVALID_MAPPING": "Cette colonne n'est pas valide pour le type de données sélectionné",
    "GIS_UPLOAD.TABLE.MAPPING_TITLE": "Mappage des colonnes sélectionnées",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.DELETE": "Supprimer",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.SAVE": "Enregistrer les modifications",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE": "Type de colonne",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE.PLACEHOLDER": "Sélectionnez le type de colonne",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS": "Unités",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS.PLACEHOLDER": "Sélectionnez les unités",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE": "Valeur",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL": "Valeur",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL.PLACEHOLDER": "Entrez une valeur pour toutes les cellules de la colonne",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE.PLACEHOLDER": "Sélectionnez une valeur pour toutes les cellules de la colonne",
    "GIS_UPLOAD.TABLE.NO_MAPPING_OPTIONS": "Aucune option de mappage",
    "GIS_UPLOAD.TABLE.SELECT_COLUMN": "Veuillez sélectionner une colonne",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN": "Mettre à jour la colonne",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN_ERROR": "Une erreur s'est produite : impossible de mettre à jour la colonne",
    "GIS_UPLOAD.UPLOAD.ERROR": "Erreur de téléchargement, réessayez.",
    "GIS_UPLOAD.UPLOAD.LABEL": "Télécharger le fichier Shapefile",
    "HEADER.BROWSE": "Parcourir",
    "HEADER.COMPANIES": "Entreprises",
    "HEADER.CONSUMPTION_PROFILE": "Profil de consommation",
    "HEADER.CORRELATION": "Corrélation",
    "HEADER.DASHBOARD": "Tableau de bord",
    "HEADER.DPLE": "Performance de livraison Ingénieur de fuite",
    "HEADER.DPST": "Technicien en capteurs de performance de livraison",
    "HEADER.GIS_ADMIN": "Administrateur SIG",
    "HEADER.GIS_UPLOAD": "Téléchargement du SIG",
    "HEADER.HOME": "Maison",
    "HEADER.JOB_DETAILS": "Détails de l'emploi",
    "HEADER.LOGS": "Journaux des modifications",
    "HEADER.PROFILE": "Profil",
    "HEADER.PROJECT_STATUS": "État d'avancement du projet",
    "HEADER.RELAY_MANAGEMENT": "Gestion des relais",
    "HEADER.REPORTS": "Rapports",
    "HEADER.SENSOR_MANAGEMENT": "Gestion des capteurs",
    "HEADER.SESSION": "Informations sur la session",
    "HEADER.STOCK_MANAGEMENT": "Gestion des stocks",
    "HEADER.TOP_SOUND": "Top Sound",
    "HEADER.USERS": "Gestion des utilisateurs",
    "HEADER.WAYPOINT": "Point de passage",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_GRAPHS": "Aucun graphique historique ou de nuit n'est disponible",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_HISTORICAL_GRAPHS": "Pas de graphiques historiques disponibles",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_OVERNIGHT_GRAPHS": "Pas de graphique de nuit disponible",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.HISTORICAL": "Graphique historique de la session",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.OVERNIGHT": "Graphique de la session de nuit",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.HISTORY": "L'histoire",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.OVERNIGHT": "Nuitée",
    "HOME_PAGE.DESCRIPTION": "Bienvenue dans le Hub où vous pouvez gérer vos tâches, assister vos utilisateurs et consulter toutes les données de votre service FIDO Smart. Comment pouvons-nous vous aider aujourd'hui ?",
    "HOME_PAGE.HELLO": "Bonjour, {{name}}",
    "HOME_PAGE.HERO_IMAGE_ALT": "Image principale",
    "HOME_PAGE.LOCATE_LEAKS.DESCRIPTION": "Parcourez les points de cheminement par taille et surveillez les enquêtes",
    "HOME_PAGE.LOCATE_LEAKS.TITLE": "Localiser les fuites",
    "HOME_PAGE.MANAGE_PROJECTS.DESCRIPTION": "Suivre l'avancement du projet et visualiser l'activité passée",
    "HOME_PAGE.MANAGE_PROJECTS.TITLE": "Gérer des projets",
    "HOME_PAGE.MONITOR_NETWORK.DESCRIPTION": "Gérez vos capteurs fixes et optimisez la connectivité",
    "HOME_PAGE.MONITOR_NETWORK.TITLE": "Surveillez votre réseau",
    "HOME_PAGE.NO_ACTIVITIES_FOUND": "Aucune activité trouvée",
    "HOME_PAGE.YOUR_DASHBOARDS.DESCRIPTION": "Analyser et rendre compte des données de performance clés",
    "HOME_PAGE.YOUR_DASHBOARDS.TITLE": "Vos tableaux de bord",
    "HOME_PAGE.YOUR_LATEST_ACTIVITIES": "Vos dernières activités",
    "INVITATIONS.ACCEPT.CONTEXT.EMAIL": "E-mail",
    "INVITATIONS.ACCEPT.CONTEXT.NOT_PROVIDED": "Non fourni",
    "INVITATIONS.ACCEPT.CONTEXT.ORGANIZATION": "Organisation",
    "INVITATIONS.ACCEPT.CONTEXT.ROLE": "Rôle",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.DESCRIPTION": "Connectez-vous avec votre compte existant pour continuer.",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.TITLE": "Invitation déjà acceptée",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.DESCRIPTION": "Cette invitation n'est plus valide. Veuillez contacter votre administrateur si vous avez encore besoin d'y accéder.",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.TITLE": "Invitation annulée",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.DESCRIPTION": "Ce lien d'invitation n'est plus actif. Veuillez demander une nouvelle invitation à votre administrateur.",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.TITLE": "L'invitation a expiré.",
    "INVITATIONS.ACCEPT.ERROR.INVALID.DESCRIPTION": "Cette invitation n'est pas valide ou a expiré. Veuillez demander une nouvelle invitation à votre administrateur.",
    "INVITATIONS.ACCEPT.ERROR.INVALID.TITLE": "Invitation invalide",
    "INVITATIONS.ACCEPT.ERROR.SUBMIT_FAILURE": "Refusé l'invitation",
    "INVITATIONS.ACCEPT.FIELDS.CONFIRM_PASSWORD": "Confirmez le mot de passe",
    "INVITATIONS.ACCEPT.FIELDS.COUNTRY": "Pays",
    "INVITATIONS.ACCEPT.FIELDS.CURRENCY": "Devise",
    "INVITATIONS.ACCEPT.FIELDS.DIAMETER": "Diamètre",
    "INVITATIONS.ACCEPT.FIELDS.FIRST_NAME": "Prénom",
    "INVITATIONS.ACCEPT.FIELDS.FLOW_RATE": "débit",
    "INVITATIONS.ACCEPT.FIELDS.LAST_NAME": "Nom de famille",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_ARIA": "Accepter la politique de confidentialité et les conditions générales",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_CONJUNCTION": "et",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_PREFIX": "J'accepte",
    "INVITATIONS.ACCEPT.FIELDS.LONG_DISTANCE": "Longue distance",
    "INVITATIONS.ACCEPT.FIELDS.MEASUREMENT_SYSTEM": "Système de mesure",
    "INVITATIONS.ACCEPT.FIELDS.PASSWORD": "Mot de passe",
    "INVITATIONS.ACCEPT.FIELDS.PHONE": "Téléphone",
    "INVITATIONS.ACCEPT.FIELDS.SELECT_PLACEHOLDER": "Sélectionner",
    "INVITATIONS.ACCEPT.FIELDS.SHORT_DISTANCE": "Courte distance",
    "INVITATIONS.ACCEPT.FIELDS.VOLUME": "Volume",
    "INVITATIONS.ACCEPT.FIELDS.WEIGHT": "Poids",
    "INVITATIONS.ACCEPT.FORM_ARIA_LABEL": "Accepter l'invitation",
    "INVITATIONS.ACCEPT.LINKS.PRIVACY_POLICY": "Politique de confidentialité",
    "INVITATIONS.ACCEPT.LINKS.TERMS_AND_CONDITIONS": "Termes et conditions",
    "INVITATIONS.ACCEPT.LOADING": "Chargement de l'invitation",
    "INVITATIONS.ACCEPT.SUBMIT": "Créer un compte",
    "INVITATIONS.ACCEPT.SUBMITTING": "J'accepte l'invitation…",
    "INVITATIONS.ACCEPT.SUCCESS.DESCRIPTION": "Votre compte est prêt. Connectez-vous pour continuer.",
    "INVITATIONS.ACCEPT.SUCCESS.SIGN_IN_CTA": "Se connecter",
    "INVITATIONS.ACCEPT.SUCCESS.TITLE": "Votre compte est prêt",
    "INVITATIONS.ACCEPT.TITLE": "Accepter l'invitation",
    "INVITATIONS.ACTION.CANCEL": "Annuler",
    "INVITATIONS.ACTION.SUBMIT": "Envoyer une invitation",
    "INVITATIONS.DIALOG.DESCRIPTION": "Invitez un utilisateur par e-mail. Il apparaîtra dans la liste des utilisateurs une fois qu'il aura accepté l'invitation.",
    "INVITATIONS.DIALOG.TITLE": "Inviter un utilisateur",
    "INVITATIONS.SUCCESS.SENT": "Invitation envoyée. L'utilisateur apparaîtra dans la liste des utilisateurs après avoir accepté l'invitation.",
    "INVITATIONS.VALIDATION.DIAMETER": "L'unité de diamètre est requise.",
    "INVITATIONS.VALIDATION.FLOW_RATE": "L'unité de débit est requise",
    "INVITATIONS.VALIDATION.GENERIC": "Un problème est survenu lors de l'invitation de cet utilisateur. Veuillez vérifier les informations et réessayer.",
    "INVITATIONS.VALIDATION.LEGAL_ACCEPTANCE": "La politique de confidentialité et les conditions générales doivent être acceptées.",
    "INVITATIONS.VALIDATION.LONG_DISTANCE": "Un appareil longue distance est nécessaire",
    "INVITATIONS.VALIDATION.PASSWORD_COMPLEXITY": "Le mot de passe doit contenir au moins trois des caractères suivants : minuscules, majuscules, chiffres et caractères spéciaux",
    "INVITATIONS.VALIDATION.PASSWORD_MAX": "Le mot de passe ne doit pas dépasser 64 caractères.",
    "INVITATIONS.VALIDATION.SHORT_DISTANCE": "Une unité de courte portée est requise.",
    "INVITATIONS.VALIDATION.VOLUME": "L'unité de volume est requise",
    "INVITATIONS.VALIDATION.WEIGHT": "Une unité de poids est requise.",
    "JOB_DETAILS.ADDRESS": "Adresse de la fuite",
    "JOB_DETAILS.AI_LEAK": "L'IA prédit la taille de la fuite",
    "JOB_DETAILS.BACK_BUTTON": "Retourner au point de repère",
    "JOB_DETAILS.CANCEL": "Annuler",
    "JOB_DETAILS.COMMENTS": "Notes",
    "JOB_DETAILS.DATE_INFO_TITLE": "Informations sur la date",
    "JOB_DETAILS.DATE_SECTION.CREATED": "Date de création",
    "JOB_DETAILS.DATE_SECTION.REPAIR": "Date de réparation",
    "JOB_DETAILS.DATE_SECTION.TITLE": "Date Heure",
    "JOB_DETAILS.DATE_SECTION.UPDATED": "Date de mise à jour",
    "JOB_DETAILS.DMA": "Référence DMA",
    "JOB_DETAILS.EDIT": "Modifier les détails de l'emploi",
    "JOB_DETAILS.ENGINEER": "Ingénieur désigné",
    "JOB_DETAILS.ENVIRONMENTAL_NOTE": "Note sur l'environnement",
    "JOB_DETAILS.ERROR": "Échec de la mise à jour du travail",
    "JOB_DETAILS.FLOW": "Réduction du débit",
    "JOB_DETAILS.FLOW_REDUCTION": "Réduction du débit convenu",
    "JOB_DETAILS.ID": "Job ID",
    "JOB_DETAILS.JOB_IMAGES_TITLE": "Images d'emploi",
    "JOB_DETAILS.JOB_INFO_TITLE": "Informations sur l'emploi",
    "JOB_DETAILS.LEAK": "Estimation de la taille de la fuite par le client",
    "JOB_DETAILS.LEAK_SIZE": "Taille estimée de la fuite",
    "JOB_DETAILS.LEAK_TYPE": "Estimation du type de fuite sur site",
    "JOB_DETAILS.LOCATION_INFO_TITLE": "Informations sur l'emplacement",
    "JOB_DETAILS.MATERIAL": "Matériau du tube",
    "JOB_DETAILS.NO_IMAGES": "Pas d'images",
    "JOB_DETAILS.NO_JOB": "Emploi non trouvé avec l'identifiant",
    "JOB_DETAILS.NOMINAL": "Estimation de la taille de la fuite par le client/volume nominal",
    "JOB_DETAILS.NOTES": "Notes sur l'environnement",
    "JOB_DETAILS.PROJECT": "Projet",
    "JOB_DETAILS.ROAD_SPEED": "Vitesse de la route",
    "JOB_DETAILS.SAVE": "Économiser",
    "JOB_DETAILS.SIZE": "Taille du tube",
    "JOB_DETAILS.STATUS": "Statut de l'emploi",
    "JOB_DETAILS.SURFACE": "Type de surface",
    "JOB_DETAILS.TITLE": "Détails de l'emploi",
    "JOB_DETAILS.TYPE": "Type d'emploi",
    "JOB_DETAILS.W3W": "What3Words",
    "JOB_DETAILS.WAYPOINT": "ID du point de passage",
    "JOB_DETAILS.WAYPOINT_STATUS": "Statut du point de passage",
    "JOB_DETAILS.WORK_ORDER": "Référence de l'ordre de travail du client/de l'entreprise de service public",
    "LANGUAGE.ENGLISH": "Anglais",
    "LANGUAGE.FRENCH": "Français",
    "LANGUAGE.ITALIAN": "Italien",
    "LANGUAGE.POLISH": "polonais",
    "LANGUAGE.SPANISH": "Espagnol",
    "LIST_VIEW.CONSUMPTION_PROFILE": "Profil de consommation",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_FROM": "Dater de",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TO": "Date à",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TYPE": "Type de date",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.awaiting_upload": "En attente de téléchargement",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.completed": "Complété",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.deleted": "Supprimé",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.in_progress": "En cours",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.BUTTON_LABEL": "Personnaliser la vue",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.DESCRIPTION": "Faites glisser les en-têtes de colonne pour réorganiser l'ordre, cochez/décochez pour afficher/masquer les colonnes du tableau.",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.RESET_BUTTON_LABEL": "Réinitialiser la vue par défaut",
    "LIST_VIEW.CONSUMPTION_PROFILE.FILTER_SECTION": "Filtre",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.address": "Adresse",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.collected_by": "Recueilli par",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.company": "Entreprise",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.deployed_by": "Déployé par",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.dma_key": "DMA",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_date": "Date de fin",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_time": "Fin des temps",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.id": "IDENTIFIANT",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.latitude": "Latitude",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.longitude": "Longitude",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.partner": "Partenaire",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.project": "Projet",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_date": "Date de début",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_time": "Heure de début",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_id": "ID du point de cheminement",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_name": "Nom du point de cheminement",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.what3words": "What3Words",
    "LIST_VIEW.CONSUMPTION_PROFILE.NO_DATA": "Aucune donnée disponible",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.APPLY.FILTER": "Appliquer des filtres",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.RESET": "Réinitialiser tous les filtres",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH.PLACEHOLDER": "Recherche...",
    "LIST_VIEW.CONSUMPTION_PROFILE.TITLE": "Parcourir tous les profils de consommation",
    "LIST_VIEW.JOBS": "Emplois",
    "LIST_VIEW.JOBS.HEADERS.address": "Adresse",
    "LIST_VIEW.JOBS.HEADERS.agreed_flow_reduction": "Réduction de Débit Convenue",
    "LIST_VIEW.JOBS.HEADERS.branch_id": "Projet",
    "LIST_VIEW.JOBS.HEADERS.client_leak_size_estimate": "Estimation de la taille de fuite du client",
    "LIST_VIEW.JOBS.HEADERS.comment": "Commentaire",
    "LIST_VIEW.JOBS.HEADERS.created_at": "Créé",
    "LIST_VIEW.JOBS.HEADERS.date_raised_externally": "Date de signalement externe",
    "LIST_VIEW.JOBS.HEADERS.date_raised_internally": "Date de signalement interne",
    "LIST_VIEW.JOBS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.JOBS.HEADERS.environmental_notes": "Notes environnementales",
    "LIST_VIEW.JOBS.HEADERS.estimate_leak_size": "Taille estimée de la fuite",
    "LIST_VIEW.JOBS.HEADERS.id": "ID",
    "LIST_VIEW.JOBS.HEADERS.job_status": "Statut de l'emploi",
    "LIST_VIEW.JOBS.HEADERS.last_scheduled_engineer_id": "Ingénieur",
    "LIST_VIEW.JOBS.HEADERS.leak_type": "Code d'emploi",
    "LIST_VIEW.JOBS.HEADERS.material": "Matériel",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter": "Taille du tuyau",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter_unit": "Unité de taille de tuyau",
    "LIST_VIEW.JOBS.HEADERS.repair_date": "Date de réparation",
    "LIST_VIEW.JOBS.HEADERS.road_speed": "Vitesse routière",
    "LIST_VIEW.JOBS.HEADERS.updated_at": "Mis à jour",
    "LIST_VIEW.JOBS.HEADERS.waypoint_id": "Point de passage",
    "LIST_VIEW.JOBS.HEADERS.work_order": "Bon de travail",
    "LIST_VIEW.JOBS.SUMMARY.JOB_TYPE": "Type d'emploi",
    "LIST_VIEW.JOBS.SUMMARY.SESSION_TYPE": "Type de session",
    "LIST_VIEW.JOBS.TITLE": "Parcourir tous les emplois",
    "LIST_VIEW.RELAYS": "Appareils de relais",
    "LIST_VIEW.RELAYS.HEADERS.address": "Adresse",
    "LIST_VIEW.RELAYS.HEADERS.bug_id": "Adresse MAC",
    "LIST_VIEW.RELAYS.HEADERS.bug_mac": "Adresse MAC",
    "LIST_VIEW.RELAYS.HEADERS.company": "Entreprise",
    "LIST_VIEW.RELAYS.HEADERS.company_name": "Entreprise",
    "LIST_VIEW.RELAYS.HEADERS.create_time": "Date de création",
    "LIST_VIEW.RELAYS.HEADERS.dma_name": "DMA",
    "LIST_VIEW.RELAYS.HEADERS.last_contact": "Dernier contact",
    "LIST_VIEW.RELAYS.HEADERS.last_update": "Dernier téléversement",
    "LIST_VIEW.RELAYS.HEADERS.latitude": "Latitude",
    "LIST_VIEW.RELAYS.HEADERS.longitude": "Longitude",
    "LIST_VIEW.RELAYS.HEADERS.partner": "Partenaire",
    "LIST_VIEW.RELAYS.HEADERS.partner_name": "Partenaire",
    "LIST_VIEW.RELAYS.HEADERS.project": "Projet",
    "LIST_VIEW.RELAYS.HEADERS.project_name": "Projet",
    "LIST_VIEW.RELAYS.HEADERS.relay_id": "ID de relais",
    "LIST_VIEW.RELAYS.HEADERS.relay_name": "Nom du relais",
    "LIST_VIEW.RELAYS.HEADERS.relay_status": "État du relais",
    "LIST_VIEW.RELAYS.HEADERS.relay_uptime": "Temps de fonctionnement du relais",
    "LIST_VIEW.RELAYS.HEADERS.session_id": "Session",
    "LIST_VIEW.RELAYS.HEADERS.session_leak_size": "Taille prédite par l'IA de session",
    "LIST_VIEW.RELAYS.HEADERS.update_time": "Heure de mise à jour",
    "LIST_VIEW.RELAYS.HEADERS.what3words": "What3Words",
    "LIST_VIEW.RELAYS.TITLE": "Parcourir tous les appareils Relay",
    "LIST_VIEW.SELECT_DATA_TYPE.LABEL": "Type de données",
    "LIST_VIEW.SELECT_DATA_TYPE.PLACEHOLDER": "Sélectionnez le type de données",
    "LIST_VIEW.SESSIONS": "Sessions",
    "LIST_VIEW.SESSIONS.DATE_FROM": "Date de début",
    "LIST_VIEW.SESSIONS.DATE_TO": "Date à",
    "LIST_VIEW.SESSIONS.DATE_TYPE": "Date Type",
    "LIST_VIEW.SESSIONS.DISTINCT.awaiting_upload": "En attente de téléchargement",
    "LIST_VIEW.SESSIONS.DISTINCT.completed": "Terminé",
    "LIST_VIEW.SESSIONS.DISTINCT.deleted": "Supprimé",
    "LIST_VIEW.SESSIONS.DISTINCT.in_progress": "En cours",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.BUTTON_LABEL": "Personnaliser la vue",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.DESCRIPTION": "Faites glisser les titres des colonnes pour réorganiser l'ordre, cochez/décochez pour afficher/masquer les colonnes du tableau.",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.RESET_BUTTON_LABEL": "Rétablir la vue par défaut",
    "LIST_VIEW.SESSIONS.FILTER_SECTION": "Filtre",
    "LIST_VIEW.SESSIONS.HEADERS.address": "Adresse",
    "LIST_VIEW.SESSIONS.HEADERS.asset_id": "Actif",
    "LIST_VIEW.SESSIONS.HEADERS.collected_by": "Recueilli par",
    "LIST_VIEW.SESSIONS.HEADERS.company_id": "Entreprise",
    "LIST_VIEW.SESSIONS.HEADERS.created": "Date de création",
    "LIST_VIEW.SESSIONS.HEADERS.deployed_by": "Déployé par",
    "LIST_VIEW.SESSIONS.HEADERS.dma_id": "DMA",
    "LIST_VIEW.SESSIONS.HEADERS.end_time": "Date de fin",
    "LIST_VIEW.SESSIONS.HEADERS.expected_finish": "Finalité attendue",
    "LIST_VIEW.SESSIONS.HEADERS.last_update": "Dernière mise à jour",
    "LIST_VIEW.SESSIONS.HEADERS.latitude": "Latitude",
    "LIST_VIEW.SESSIONS.HEADERS.leak_size": "Taille prévue",
    "LIST_VIEW.SESSIONS.HEADERS.longitude": "Longitude",
    "LIST_VIEW.SESSIONS.HEADERS.partner_id": "Partenaire",
    "LIST_VIEW.SESSIONS.HEADERS.project_id": "Projet",
    "LIST_VIEW.SESSIONS.HEADERS.relay_connected": "Relais connecté",
    "LIST_VIEW.SESSIONS.HEADERS.sensor-id": "ID du capteur",
    "LIST_VIEW.SESSIONS.HEADERS.session_id": "Nom de la session",
    "LIST_VIEW.SESSIONS.HEADERS.start_time": "Date de début",
    "LIST_VIEW.SESSIONS.HEADERS.status_id": "Statut",
    "LIST_VIEW.SESSIONS.HEADERS.type": "Type",
    "LIST_VIEW.SESSIONS.HEADERS.what3words": "W3W",
    "LIST_VIEW.SESSIONS.NO_DATA": "Pas de données disponibles",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.APPLY.FILTER": "Appliquer les filtres",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.RESET": "Réinitialiser tous les filtres",
    "LIST_VIEW.SESSIONS.SEARCH.PLACEHOLDER": "Recherche...",
    "LIST_VIEW.SESSIONS.SUMMARY.LEAK_SIZE": "Taille de la fuite",
    "LIST_VIEW.SESSIONS.SUMMARY.SESSION_TYPE": "Type de session",
    "LIST_VIEW.SESSIONS.SUMMARY.TITLE": "Résumé",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.DESC": "Pour ajuster les données affichées ici, utilisez les filtres du tableau ci-dessus.",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.TITLE": "Résumé des données obtenues",
    "LIST_VIEW.SESSIONS.SUMMARY.WAYPOINT_STATUS": "Statut du point de passage",
    "LIST_VIEW.SESSIONS.TITLE": "Parcourir toutes les sessions",
    "LIST_VIEW.WAYPOINT_LOGS": "Journaux de points de passage",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_from_status_name": "Statut précédent",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_to_status_name": "Statut actuel",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.company": "Entreprise",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.datetime": "Date de mise à jour",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.id": "ID",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.notes": "Notes",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.partner": "Partenaire",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.project": "Projet",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.user_name": "Nom d'utilisateur",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.waypoint_id": "Point de passage",
    "LIST_VIEW.WAYPOINT_LOGS.TITLE": "Parcourir tous les journaux de points de passage",
    "LIST_VIEW.WAYPOINTS": "Points de passage",
    "LIST_VIEW.WAYPOINTS.HEADERS.address": "Adresse",
    "LIST_VIEW.WAYPOINTS.HEADERS.agreed_flow_reduction": "Réduction du débit convenue",
    "LIST_VIEW.WAYPOINTS.HEADERS.branch_name": "Projet",
    "LIST_VIEW.WAYPOINTS.HEADERS.comment": "Commentaire",
    "LIST_VIEW.WAYPOINTS.HEADERS.company_id": "Entreprise",
    "LIST_VIEW.WAYPOINTS.HEADERS.created_at": "Créé le",
    "LIST_VIEW.WAYPOINTS.HEADERS.date_time": "Date de mise à jour",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter": "Diamètre",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter_unit": "Unité de diamètre",
    "LIST_VIEW.WAYPOINTS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINTS.HEADERS.environmental_notes": "Notes environnementales",
    "LIST_VIEW.WAYPOINTS.HEADERS.estimated_size": "Taille estimée",
    "LIST_VIEW.WAYPOINTS.HEADERS.job_type_code": "Code de type d'emploi",
    "LIST_VIEW.WAYPOINTS.HEADERS.jobs": "Emplois",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_action_by": "Dernière action par",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_scheduled_engineer_id": "Dernier ingénieur programmé",
    "LIST_VIEW.WAYPOINTS.HEADERS.latitude": "Latitude",
    "LIST_VIEW.WAYPOINTS.HEADERS.longitude": "Longitude",
    "LIST_VIEW.WAYPOINTS.HEADERS.material": "Matériel",
    "LIST_VIEW.WAYPOINTS.HEADERS.name": "Nom",
    "LIST_VIEW.WAYPOINTS.HEADERS.partner_id": "Partenaire",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_leak_type_id": "Type de fuite prévu",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_size": "Taille prévue",
    "LIST_VIEW.WAYPOINTS.HEADERS.sessions": "Sessions",
    "LIST_VIEW.WAYPOINTS.HEADERS.status_id": "Statut",
    "LIST_VIEW.WAYPOINTS.HEADERS.surface_type": "Type de surface",
    "LIST_VIEW.WAYPOINTS.HEADERS.w3w": "What3Words",
    "LIST_VIEW.WAYPOINTS.TITLE": "Parcourir tous les points de passage",
    "LOGIN_PAGE.ENTRA_TITLE": "Se connecter au portail",
    "LOGIN_PAGE.ERROR.MSG": "Courriel ou mot de passe incorrect",
    "LOGIN_PAGE.FORGOT_PASSWORD": "Mot de passe oublié ?",
    "LOGIN_PAGE.FORM.EMAIL.LABEL": "Courriel",
    "LOGIN_PAGE.FORM.EMAIL.PLACEHOLDER": "Saisissez votre adresse électronique",
    "LOGIN_PAGE.FORM.OKTA_SUBMIT": "Se connecter avec Okta",
    "LOGIN_PAGE.FORM.PASSWORD.LABEL": "Mot de passe",
    "LOGIN_PAGE.FORM.PASSWORD.PLACEHOLDER": "Entrez votre mot de passe",
    "LOGIN_PAGE.FORM.SUBMIT": "S'inscrire",
    "LOGIN_PAGE.SIGNING_IN": "Connexion en cours…",
    "LOGIN_PAGE.SIGNING_IN_SUBTITLE": "Si vous n'êtes pas redirigé automatiquement dans quelques secondes, veuillez actualiser la page.",
    "LOGIN_PAGE.SUBTITLE": "Entrez votre email et votre mot de passe ci-dessous",
    "LOGIN_PAGE.TITLE": "Se connecter au panneau d'administration",
    "LOGS.ACTION.ASSIGN_DMAs": "Attribuer des DMA",
    "LOGS.ACTION.CHANGE DATES": "Changer les dates",
    "LOGS.ACTION.Change project 1 dates": "Dates du projet de changement 1",
    "LOGS.ACTION.CHANGE_DATES": "Changer les dates",
    "LOGS.ACTION.CHANGE_PASSWORD": "Changer le mot de passe",
    "LOGS.ACTION.CREATE PROJECT": "Créer un projet",
    "LOGS.ACTION.CREATE_BRANCH": "Créer une branche",
    "LOGS.ACTION.CREATE_COMPANY": "Créer une entreprise",
    "LOGS.ACTION.CREATE_MULTI_USER": "Créer plusieurs utilisateurs",
    "LOGS.ACTION.CREATE_PARTNER": "Créer un partenaire",
    "LOGS.ACTION.CREATE_PROJECT": "Créer un projet",
    "LOGS.ACTION.CREATE_USER": "Créer un utilisateur",
    "LOGS.ACTION.DELETE_BRANCH": "Supprimer la branche",
    "LOGS.ACTION.DELETE_COMPANY": "Supprimer l'entreprise",
    "LOGS.ACTION.DELETE_DMAs": "Supprimer les DMA",
    "LOGS.ACTION.DELETE_PARTNER": "Supprimer le partenaire",
    "LOGS.ACTION.DELETE_PROJECT": "Supprimer le projet",
    "LOGS.ACTION.DELETE_USER": "Supprimer l'utilisateur",
    "LOGS.ACTION.EDIT_COMPANY": "Modifier l'entreprise",
    "LOGS.ACTION.FORGOT_PASSWORD": "Mot de passe oublié",
    "LOGS.ACTION.GET_COMPANY": "Obtenir une entreprise",
    "LOGS.ACTION.LOGIN": "Se connecter",
    "LOGS.ACTION.MODIFY_COMPANY": "Modifier l'entreprise",
    "LOGS.ACTION.MODIFY_PARTNER": "Modifier le partenaire",
    "LOGS.ACTION.MODIFY_USER": "Modifier l'utilisateur",
    "LOGS.ACTION.REACTIVATE_COMPANY": "Réactiver l'entreprise",
    "LOGS.ACTION.REACTIVATE_PARTNER": "Réactiver le partenaire",
    "LOGS.ACTION.RESTORE_COMPANY": "Restaurer l'entreprise",
    "LOGS.ACTION.SET_PASSWORD": "Définir le mot de passe",
    "LOGS.ACTION.TOGGLE OFF RELAY DEVICE": "Désactiver le dispositif relais",
    "LOGS.ACTION.TRIGGER RELAY DEVICE": "Dispositif de relais de déclenchement",
    "LOGS.ACTION.UPDATE WAYPOINT": "Mettre à jour le point de cheminement",
    "LOGS.ACTION.UPDATE_BRANCH": "Mettre à jour la branche",
    "LOGS.ACTION.UPDATE_LOGGER_SESSION": "Mettre à jour la session du journal",
    "LOGS.DESCRIPTION.ASSIGN_DMAs": "DMA attribués {{dma_keys}} à {{project_name}}",
    "LOGS.DESCRIPTION.CHANGE_DATES": "Dates modifiées pour {{project_name}}. Date de début : {{start_date}}. Date de fin : {{end_date}}",
    "LOGS.DESCRIPTION.COMMON.BY_USER_EMAIL": "par {{by_email}}",
    "LOGS.DESCRIPTION.CREATE_BRANCH": "Projet créé {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_COMPANY": "Création de la société {{company_name}}",
    "LOGS.DESCRIPTION.CREATE_PROJECT": "Projet créé {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_USER": "Utilisateur créé {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.DELETE_PROJECT": "Projet supprimé {{project_name}}",
    "LOGS.DESCRIPTION.DELETE_USER": "Utilisateur supprimé {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.MODIFY_COMPANY": "Société modifiée {{company_name}}",
    "LOGS.DESCRIPTION.MODIFY_PARTNER": "Partenaire modifié {{partner_name}}",
    "LOGS.DESCRIPTION.MODIFY_USER": "Utilisateur modifié {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.UPDATE_LOGGER_SESSION": "Session de journalisation mise à jour {{session_id}}",
    "MAP_UNITS.TITLE.COLUMN": "Colonne de carte",
    "MAP_UNITS.TITLE.UNITS": "Mapper les valeurs des unités",
    "MAP_VIEW.DIALOG.SUBTITLE.CHANGE": "Tous les filtres seront supprimés ?",
    "MAP_VIEW.DIALOG.SUBTITLE.CLOSE": "Les modifications seront supprimées",
    "MAP_VIEW.DIALOG.TITLE.CHANGE": "Êtes-vous sûr de vouloir modifier la source de données ?",
    "MAP_VIEW.DIALOG.TITLE.CLOSE": "Êtes-vous sûr de vouloir fermer les paramètres ?",
    "MAP_VIEW.FILTERS.BUTTONTITLE": "Options de carte",
    "MAP_VIEW.FILTERS.SUBMIT": "Soumettre",
    "MAP_VIEW.FILTERS.TITLES.ASSETS": "Actifs",
    "MAP_VIEW.FILTERS.TITLES.AWAITING_UPLOAD_SESSION": "En attente de la session de téléchargement",
    "MAP_VIEW.FILTERS.TITLES.DELETED_SESSION": "Session supprimée",
    "MAP_VIEW.FILTERS.TITLES.DMAS": "DMA",
    "MAP_VIEW.FILTERS.TITLES.IN_PROGRESS_SESSION": "Session en cours",
    "MAP_VIEW.FILTERS.TITLES.INVESTIGATION_SESSION": "Séance d'enquête",
    "MAP_VIEW.FILTERS.TITLES.LARGE_LEAK_SESSION": "Session sur les fuites importantes",
    "MAP_VIEW.FILTERS.TITLES.MEDIUM_LEAK_SESSION": "Session de fuite moyenne",
    "MAP_VIEW.FILTERS.TITLES.NON_LEAK_SESSION": "Session sans fuite",
    "MAP_VIEW.FILTERS.TITLES.ODL": "ODL",
    "MAP_VIEW.FILTERS.TITLES.PIPES": "Tuyaux",
    "MAP_VIEW.FILTERS.TITLES.SMALL_LEAK_SESSION": "Session sur les petites fuites",
    "MAP_VIEW.FILTERS.TITLES.WAYPOINTS": "Points de repère",
    "MAP_VIEW.FORM.SOURCE.LABEL": "Source des données",
    "MAP_VIEW.FORM.SOURCE.PLACEHOLDER": "Sélectionner la source de données",
    "MAP_VIEW.LOADING": "Chargement de la carte",
    "MAP_VIEW.MODAL_TITLE": "Paramètres",
    "MAP.HUD.FETCH_BOUNDARIES": "Limites de récupération",
    "MAP.HUD.LAT": "Lat:",
    "MAP.HUD.LNG": "Lng:",
    "MAP.HUD.SOURCES": "Sources :",
    "MAP.HUD.TOGGLE_FETCH_BOUNDARY_VISUALIZATION": "Afficher/masquer la visualisation des limites de récupération",
    "MAP.HUD.ZOOM_IN_TO_LOAD": "Zoomez pour charger",
    "MAP.STYLE.SATELLITE": "vue satellite",
    "MAP.STYLE.STREET": "vue de la rue",
    "MEASUREMENT_TYPE.IMPERIAL": "Impérial",
    "MEASUREMENT_TYPE.METRIC": "Métrique",
    "MERGE_WAYPOINT.FORM.SUBMIT": "Soumettre",
    "MERGE_WAYPOINT.FORM.SUCCESS": "Points de passage fusionnés avec succès",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL": "Fusionner le point de repère sélectionné avec le point de repère actuel",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL_SHORT": "Point de passage",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.PLACEHOLDER": "Sélectionner un point de passage",
    "MERGE_WAYPOINT.INPUT.NOTES.LABEL": "Notes",
    "MERGE_WAYPOINT.INPUT.NOTES.PLACEHOLDER": "Saisir les notes",
    "MERGE_WAYPOINT.NO_DATA": "Aucun point de passage n'est disponible pour la fusion",
    "METRIC_WIDGET.DESCRIPTION": "par jour",
    "METRIC_WIDGET.TITLE_A": "IA identifiée",
    "METRIC_WIDGET.TITLE_B": "Pour la réparation",
    "METRIC_WIDGET.TITLE_C": "Livré",
    "NOT_FOUND_PAGE.ACTION.GO_HOME": "Ramène-moi à la maison",
    "NOT_FOUND_PAGE.DESCRIPTION": "Oups ! La page que vous cherchez semble avoir disparu dans les limbes du numérique. Ne vous inquiétez pas, ça arrive même aux meilleurs.",
    "NOT_FOUND_PAGE.TITLE": "Page introuvable",
    "PIE_CHART.SUMMARY_DETAILS": "Résumé des détails",
    "PIE_CHART.SUMMARY_TOTAL": "Résultats totaux",
    "PROCESS_FILES.BUTTON.DISCARD": "Rejeter",
    "PROCESS_FILES.BUTTON.NEXT": "Suivant",
    "PROCESS_FILES.BUTTON.PREVIOUS": "Précédent",
    "PROCESS_FILES.BUTTON.RESET": "Remise à zéro",
    "PROCESS_FILES.COLUMNS_SELECT": "Colonnes obligatoires à sélectionner",
    "PROCESS_FILES.COLUMNS_SELECTED": "toutes les colonnes sélectionnées",
    "PROCESS_FILES.DESC.DIAMETER": "Veuillez sélectionner soit : une unité qui correspond à vos valeurs de diamètre OU une colonne pour mapper les valeurs d'unité",
    "PROCESS_FILES.ERROR.INSUFFICIENT_COLUMNS": "Il n'y a pas assez de colonnes pour correspondre aux données fournies. Pour continuer, veuillez rejeter ou télécharger un nouveau fichier.",
    "PROCESS_FILES.ERROR.NO_FILE_TO_MAP": "Pas de fichier à cartographier pour {{type}} veuillez continuer en cliquant sur suivant",
    "PROCESS_FILES.ERROR.SELECT_ALL": "Veuillez sélectionner toutes les colonnes",
    "PROCESS_FILES.FILENAME": "Nom de fichier",
    "PROCESS_FILES.INSTRUCTIONS": "Veuillez associer les colonnes aux en-têtes proposés dans les menus déroulants. Une seule colonne peut être associée à un en-tête.",
    "PROCESS_FILES.MAP_FIELD_TITLE": "Mapper le champ {{title}}",
    "PROCESS_FILES.OPTION_COLUMNS_SELECT": "Colonnes facultatives à sélectionner",
    "PROCESS_FILES.OPTIONAL_COLUMNS_SELECTED": "Toutes les colonnes optionnelles ont été sélectionnées",
    "PROCESS_FILES.TITLE.DIAMETER": "Champ de diamètre de la carte",
    "PROFILE_PAGE.BRANCH": "Projet :",
    "PROFILE_PAGE.COMPANY": "Entreprise :",
    "PROFILE_PAGE.COMPANY_ADDRESS": "Adresse :",
    "PROFILE_PAGE.COMPANY_NAME": "Nom :",
    "PROFILE_PAGE.DISCARD": "Rejeter",
    "PROFILE_PAGE.EDIT": "Editer",
    "PROFILE_PAGE.EMAIL": "Courriel :",
    "PROFILE_PAGE.ERROR.FAILED_LOADING_USER_DATA": "Échec du chargement des données utilisateur.",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.BAD_AUTH": "Mot de passe incorrect",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.ERROR": "Mot de passe actuel incorrect",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.LOADING": "Chargement",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUBMIT": "Soumettre un nouveau mot de passe",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUCCESS": "Succès ! Votre mot de passe a été modifié.",
    "PROFILE_PAGE.FORM.EMAIL.LABEL": "Courriel",
    "PROFILE_PAGE.FORM.EMAIL.PLACEHOLDER": "Saisir l'adresse électronique",
    "PROFILE_PAGE.FORM.FIRST_NAME.LABEL": "Prénom",
    "PROFILE_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Saisir le prénom",
    "PROFILE_PAGE.FORM.LAST_NAME.LABEL": "Nom de famille",
    "PROFILE_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Saisir le nom de famille",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.LABEL": "Type de mesure",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.PLACEHOLDER": "Sélectionner un type de mesure",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.LABEL": "Nouveau mot de passe",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.PLACEHOLDER": "Saisir un nouveau mot de passe",
    "PROFILE_PAGE.FORM.PASSWORD.LABEL": "Mot de passe",
    "PROFILE_PAGE.FORM.PASSWORD.PLACEHOLDER": "Saisir le mot de passe",
    "PROFILE_PAGE.ROLE": "Rôle :",
    "PROFILE_PAGE.SUBMIT": "Économiser",
    "PROFILE_PAGE.TABS.ACCOUNT_SETTINGS": "Paramètres du compte",
    "PROFILE_PAGE.TABS.CHANGE_PASSWORD": "Modifier le mot de passe",
    "PROFILE_PAGE.TABS.COMPANY_SETTINGS": "Paramètres de l'entreprise",
    "PROFILE_PAGE.TABS.DOCUMENTS": "Documents",
    "PROFILE_PAGE.TITLE": "Modifier le profil",
    "PROJECT_ADMIN.TITLE": "Administrateur de projet",
    "PROJECT_CREATE.ERROR.PROJECT_CREATION": "Une erreur s'est produite : impossible de créer le projet",
    "PROJECT_CREATE.FOOTER.CREATE_DRAFT": "Créer un brouillon",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_1": "Vous pouvez y accéder dans votre section « Voir les projets ».",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_2": "Avant de le soumettre pour approbation, veuillez ajouter tous les détails requis.",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECT": "Ajouter des détails",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECTS": "Voir les projets",
    "PROJECT_CREATE.SUCCESS.TITLE": "Un projet préliminaire a été créé",
    "PROJECT_STATUS.INCOMPLETE_PROJECT_SETUP": "La configuration du projet est incomplète",
    "PROJECT_STATUS.SUMMARY.TITLES.CONFIRMEDLEAKS": "# Nombre de fuites confirmées",
    "PROJECT_STATUS.SUMMARY.TITLES.LEAKSMARKEDUP": "# Nombre de fuites répertoriées",
    "PROJECT_STATUS.SUMMARY.TITLES.SESSIONS": "# Nombre de sessions",
    "PROJECT_STATUS.SUMMARY.TITLES.WAYPOINTS": "# Nombre de points de passage",
    "PROJECT_STATUS.TITLE": "État d'avancement du projet",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CANCEL": "Annuler",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CONFIRM": "Confirmer la suppression du brouillon",
    "PROJECT_UPDATE.DELETE_DIALOG.DESCRIPTION": "Êtes-vous sûr de vouloir supprimer ce brouillon ?",
    "PROJECT_UPDATE.DELETE_DIALOG.TITLE": "Supprimer le brouillon",
    "PROJECT_UPDATE.DELETE_DRAFT": "Supprimer le brouillon",
    "PROJECT_UPDATE.DELETE_PROJECT": "Supprimer le projet",
    "PROJECT_UPDATE.ERROR.DELETE_DRAFT": "Une erreur s'est produite : impossible de supprimer le brouillon.",
    "PROJECT_UPDATE.ERROR.PROJECT_DRAFT": "Une erreur s'est produite : impossible d'enregistrer le brouillon",
    "PROJECT_UPDATE.ERROR.PROJECT_STATUS_UPDATE": "Une erreur s'est produite : impossible de mettre à jour le statut du projet",
    "PROJECT_UPDATE.ERROR.PROJECT_UPDATE": "Une erreur s'est produite : impossible de mettre à jour le projet",
    "PROJECT_UPDATE.FOOTER.CONTINUE": "Continuer",
    "PROJECT_UPDATE.FOOTER.DONE": "Fait",
    "PROJECT_UPDATE.FOOTER.PREVIOUS": "Précédent",
    "PROJECT_UPDATE.FOOTER.SAVE_DRAFT": "Enregistrer le brouillon",
    "PROJECT_UPDATE.FOOTER.SUBMIT": "Soumettre",
    "PROJECT_UPDATE.SUCCESS.DRAFT_DELETED": "Brouillon supprimé",
    "PROJECT_UPDATE.SUCCESS.PROJECT_DRAFT": "Brouillon de projet enregistré",
    "PROJECT_UPDATE.SUCCESS.PROJECT_STATUS_UPDATE": "Statut du projet mis à jour",
    "PROJECT_UPDATE.SUCCESS.PROJECT_UPDATE": "Projet mis à jour",
    "PROJECT_UPDATE.TITLE_EDIT": "Modifier le projet",
    "PROJECT_UPDATE.TITLE_VIEW": "Voir le projet",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_GENERAL": "Erreur lors du chargement de la carte",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_NO_GIS": "Aucun SIG trouvé.",
    "PROJECT.FORM.ERROR.ODL_LOADING": "Erreur lors du chargement des ODL",
    "PROJECT.FORM.GIS_DATA.DESCRIPTION": "Téléchargez de nouvelles données SIG ou choisissez-en une existante",
    "PROJECT.FORM.GIS_DATA.EXISTING_GIS_UPLOADS": "Téléchargements SIG existants",
    "PROJECT.FORM.GIS_DATA.TITLE": "Données SIG",
    "PROJECT.FORM.GIS_DATA.UPLOAD_ALTERNATIVE": "ou choisissez-en un existant",
    "PROJECT.FORM.GIS_DATA.UPLOAD_NEW_GIS": "Télécharger un nouveau SIG",
    "PROJECT.FORM.LABEL.COMPANY": "Entreprise",
    "PROJECT.FORM.LABEL.COST_PER_DISTANCE": "Coût par distance ($)",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY": "Densité de déploiement",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY_LEVEL": "Niveau {{level}}",
    "PROJECT.FORM.LABEL.DMA": "DMA",
    "PROJECT.FORM.LABEL.DMAS_LOADING": "Chargement des DMA...",
    "PROJECT.FORM.LABEL.EMPTY_GIS_PREVIEW ": "Aucun SIG téléchargé",
    "PROJECT.FORM.LABEL.END_DATE": "Date de fin",
    "PROJECT.FORM.LABEL.GIS_PREVIEW": "Aperçu du SIG",
    "PROJECT.FORM.LABEL.LEAK_RADIUS": "Rayon de fuite",
    "PROJECT.FORM.LABEL.LEAK_RADIUS_DESCRIPTION": "Ajustez le rayon de fuite pour contrôler la visibilité de l'ODL sur la carte. Les modifications sont appliquées lorsque vous relâchez le curseur.",
    "PROJECT.FORM.LABEL.ODLS_GENERATING": "Génération d'ODL...",
    "PROJECT.FORM.LABEL.PARTNER_OR_SELF_SERVE": "Partenaire ou libre-service",
    "PROJECT.FORM.LABEL.PROJECT_NAME": "Nom du projet",
    "PROJECT.FORM.LABEL.SELF_SERVE_PROJECT": "Projet libre-service",
    "PROJECT.FORM.LABEL.START_DATE": "Date de début",
    "PROJECT.FORM.LABEL.TARGET_DISTANCE": "Distance de la cible",
    "PROJECT.FORM.LABEL.TARGET_LEAKAGE": "Fuite de la cible",
    "PROJECT.FORM.LABEL.WAITING_FOR_ODL": "En attente de la génération ODL...",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_1": "Déploiement clairsemé : il peut s'agir d'une zone principalement métallique ou d'un petit budget où vous n'avez pas besoin de couvrir chaque centimètre,",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_2": "Déploiement standard : il s’agit de notre recommandation standard pour équilibrer le coût du projet et couvrir une zone composée d’un mélange de métal et de plastique.",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_3": "Couverture complète : cela peut être utilisé si vous avez un réseau plastique très complexe avec de nombreuses jonctions pour assurer une couverture garantie complète, avec une consommation de capteur élevée.",
    "PROJECT.FORM.OPTIONS.NO_MATCHING": "Aucun DMA correspondant",
    "PROJECT.FORM.PLACEHOLDER.DMA": "Sélectionnez les DMA",
    "PROJECT.FORM.PLACEHOLDER.END_DATE": "Choisissez une date",
    "PROJECT.FORM.PLACEHOLDER.START_DATE": "Choisissez une date",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.DEFINITELY": "Rejeter définitivement le projet",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.WITH_NOTES": "Rejeter le projet avec des notes",
    "PROJECT.REJECT_DIALOG.DEFINITELY.DESCRIPTION": "Cette action supprimera le projet.",
    "PROJECT.REJECT_DIALOG.DEFINITELY.TITLE": "Rejeter définitivement le projet",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.LABEL": "Remarques",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.PLACEHOLDER": "Ajoutez vos notes",
    "PROJECT.REJECT_DIALOG.OR": "ou",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.DESCRIPTION": "Le projet sera renvoyé à l'utilisateur qui l'a soumis. Il pourra le modifier et le soumettre à nouveau, ou le supprimer.",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.TITLE": "Rejeter le projet avec des notes",
    "PROJECT.TOAST.DMA.ERROR": "Erreur lors du chargement des données DMA.",
    "PROJECT.TOAST.DMA.LOADING": "Chargement des données DMA...",
    "PROJECT.TOAST.DMA.SUCCESS": "Données DMA chargées avec succès.",
    "PROJECT.TOAST.ODL.ERROR": "Erreur lors de la génération des ODL.",
    "PROJECT.TOAST.ODL.LOADING": "Génération d'ODL...",
    "PROJECT.TOAST.ODL.PENDING": "Génération ODL en attente...",
    "PROJECT.TOAST.ODL.SUCCESS": "Fichiers ODL générés avec succès.",
    "PROJECT.VIEW_REJECTION_NOTES.BUTTON_CLOSE": "J'ai compris",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.LABEL.NOTES": "Notes de l'administrateur",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.PLACEHOLDER.NOTES": "Notes laissées par l'administrateur",
    "PROJECT.VIEW_REJECTION_NOTES.TITLE": "Le projet a été rejeté par un administrateur",
    "PROJECTS.LOADING_PROJECT_INFO": "Chargement des informations du projet...",
    "RECOVERY_EXPIRED_PAGE.SUBTITLE": "Votre lien n'est plus actif",
    "RECOVERY_EXPIRED_PAGE.TITLE": "Récupération du mot de passe",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.LABEL": "Courriel",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Saisissez votre adresse électronique",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.LABEL": "Mot de passe",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.PLACEHOLDER": "Entrez votre mot de passe",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Répéter le mot de passe",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Répéter le mot de passe",
    "RECOVERY_PASSWORD_PAGE.FORM.SUBMIT": "Récupérer",
    "RECOVERY_PASSWORD_PAGE.SUBTITLE": "Entrez votre mot de passe ci-dessous",
    "RECOVERY_PASSWORD_PAGE.TITLE": "Récupération du mot de passe",
    "REPORT_BUILDER.APPLY": "Appliquer",
    "REPORT_BUILDER.BACK": "Retour",
    "REPORT_BUILDER.EXPORT_TO_PDF": "Exporter au format PDF",
    "REPORT_BUILDER.RUN": "Exécuter",
    "REPORT_BUILDER.SAVE": "Économiser",
    "REPORT_BUILDER.SORT_MODE": "Mode de tri",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.ASSET_LEAK": "Fuite d'actifs",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Fuite du compteur client/du régulateur de pression",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.COMM_PIPE_LEAK": "Fuite de tuyau de communication",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_METER_LEAK": "Fuite du compteur client",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Fuite côté client",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.FERRULE_LEAK": "Fuite de la virole",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.MAINS_LEAK": "Fuite du réseau principal",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NA": "N / A",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NETWORK_MAINTENANCE": "Maintenance du réseau",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RENEW_STOP_TAP_MSM": "Renouveler le robinet d'arrêt/MSM",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.REPAIR": "Réparation",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RESOLVED_ONSITE": "Résolu sur place",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.ASSET_LEAK": "Fuite d'actifs",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Fuite du compteur client/du régulateur de pression",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMERCIAL_REPAIR": "Réparation commerciale",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMUNICATION_PIPE": "Canal de communication",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CSL": "CSL",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_METER_LEAK": "Fuite du compteur client",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Fuite côté client",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.DECOMMISSION_FERRULE": "Virole de mise hors service",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Excavation d'un trou d'essai (Permis)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Détecteur de fuite externe > 40 mm Inc Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Indicateur de fuite externe > 40 mm Non applicable",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Détecteur de fuite externe < 40 mm Inc Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Indicateur de fuite externe < 40 mm Non applicable",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE": "Virole",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE_EXCHANGE_NO_5": "Échange de virole n° 5",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H s'est arrêté sur place",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_HYDRANT": "borne d'incendie",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_MAIN": "Conduite d'incendie",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Essai d'écoulement à la limite sans exception",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Essai d'écoulement à la limite avec Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Inst MSM pour exister Comm Pipe UnMtrd",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_FERRULE_ONLY": "Installer uniquement la virole",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_MSM_INC_METER": "Installer le compteur MSM Inc.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SAMPLE_TAP": "Installer un robinet d'essai",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SLUICE_VALVE": "Installer la vanne à guillotine",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Installer une borne d'incendie de lavage",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_FIXED_ONSITE": "Fuite réparée sur place",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_FH": "Fuite sur F/H",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Fuite au niveau de l'axe du SV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Fuite sur l'axe de la bride SV.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS": "Secteurs",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_BURST": "Explosion du réseau électrique",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_LEAK": "Fuite du réseau principal",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/A - Sans arrêt sur site",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NETWORK_MAINTENANCE": "Maintenance du réseau",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OSV_EXCHANGE": "Échange OSV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OTHER": "Autre",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_FH": "Réussite de FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_HYDRANT": "Borne d'incendie passante",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Travaux de réparation extérieurs",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Retirer la vanne de dérivation",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Renouvellement du tuyau de communication côté long",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Renouvellement du tuyau de communication côté court",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COVER_AND_FRAME_STANDARD": "Renouveler la couverture et le cadre (Standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FERRULE_ONLY": "Renouveler uniquement la virole",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT": "Renouveler la borne d'incendie",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Renouveler la chambre de la borne d'incendie",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_AND_COVER": "Renouvellement du cadre et du couvercle de la borne d'incendie",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Remplacement de la conduite d'alimentation défectueuse >10 m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Remplacer la conduite d'alimentation qui fuit <10m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Ensemble de robinet d'arrêt/MSM de renouvellement",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_SLUICE_VAVLE": "Vanne de vidange neuve",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Borne d'incendie de lavage renouvelée",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPACK_SLUICE_VALVE": "Vanne de reconditionnement",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Réparation du tuyau de communication",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Réparation LSP externe - Non admissible",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Réparation de fuite interne (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Réparation de la conduite d'alimentation qui fuit (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LOP": "Réparation LOP",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Réparation LSP - Éligible",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Pièce de cheville principale de réparation >=200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Pièce de cheville principale de réparation <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Réparation principale [pas de cheville] >=200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Réparation principale [sans cheville] <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAJOR_BURST": "Réparation d'une importante éruption",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Clapet anti-retour de réparation",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Réparation du débordement en cours (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_SLUICE_VALVE": "Vanne de réparation",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Repositionner l'ensemble MSM/robinet d'arrêt",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Réinitialiser le boîtier Surface (Standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SERVICE_LEAK": "Fuite de service",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE": "Vanne à guillotine",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE_VL": "Vanne à guillotine (VL)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_EXCHANGE": "Échange Stop Tap",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK": "Fuite du robinet",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK_NO_7": "Fuite du robinet d'arrêt n° 7",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.WO_FH": "WO / FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.LEAK": "Fuir",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.NO_LEAK": "Aucune fuite",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE": "Taille prévue",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.LARGE": "Grandes dimensions",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.MEDIUM": "Moyen",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.SMALL": "Petit",
    "REPORT.FILTERS.DROPDOWN.STATUS": "Statut",
    "REPORT.FILTERS.DROPDOWN.STATUS.1": "Éclatement",
    "REPORT.FILTERS.DROPDOWN.STATUS.10": "Inprogress ST (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.11": "Fuite connue",
    "REPORT.FILTERS.DROPDOWN.STATUS.12": "Fuite soumise au client",
    "REPORT.FILTERS.DROPDOWN.STATUS.13": "Marqué au fer rouge",
    "REPORT.FILTERS.DROPDOWN.STATUS.14": "Proposé",
    "REPORT.FILTERS.DROPDOWN.STATUS.15": "Réparation prévue",
    "REPORT.FILTERS.DROPDOWN.STATUS.16": "Réparation",
    "REPORT.FILTERS.DROPDOWN.STATUS.17": "Jours prévus",
    "REPORT.FILTERS.DROPDOWN.STATUS.18": "Nuits programmées",
    "REPORT.FILTERS.DROPDOWN.STATUS.19": "Source de bruit non confirmée",
    "REPORT.FILTERS.DROPDOWN.STATUS.2": "Source de bruit confirmée",
    "REPORT.FILTERS.DROPDOWN.STATUS.20": "Validé",
    "REPORT.FILTERS.DROPDOWN.STATUS.3": "Collecte de données",
    "REPORT.FILTERS.DROPDOWN.STATUS.4": "Supprimé",
    "REPORT.FILTERS.DROPDOWN.STATUS.5": "Creuser à sec",
    "REPORT.FILTERS.DROPDOWN.STATUS.6": "Édité",
    "REPORT.FILTERS.DROPDOWN.STATUS.7": "Travaux complémentaires demandés",
    "REPORT.FILTERS.DROPDOWN.STATUS.8": "En cours",
    "REPORT.FILTERS.DROPDOWN.STATUS.9": "Inprogress LE (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITING_SCHEDULING": "En attente de programmation",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITINGSCHEDULING": "En attente de programmation",
    "REPORT.FILTERS.DROPDOWN.STATUS.CLOSED": "Fermé",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMED_NOISE_SOURCE": "Source de bruit confirmée",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMEDNOISESOURCE": "Source de bruit confirmée",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRY_DIG": "Creuser à sec",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRYDIG": "Creuser à sec",
    "REPORT.FILTERS.DROPDOWN.STATUS.EDITED": "Édité",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHER_WORK_REQUESTED": "Travaux complémentaires demandés",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHERWORKREQUESTED": "Travaux complémentaires demandés",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAK_SUBMITTED_TO_CLIENT": "Fuite soumise au client",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAKSUBMITTEDTOCLIENT": "Fuite soumise au client",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKED_UP": "Marqué au fer rouge",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKEDUP": "Marqué au fer rouge",
    "REPORT.FILTERS.DROPDOWN.STATUS.PROPOSED": "Proposé",
    "REPORT.FILTERS.DROPDOWN.STATUS.REPAIRED": "Réparation",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULED": "Prévu",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULING": "Programmation",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED": "Non confirmé",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED_NOISE_SOURCE": "Source de bruit non confirmée",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMEDNOISESOURCE": "Source de bruit non confirmée",
    "REPORT.FILTERS.FILTER.BUTTON": "Filtres",
    "REPORT.FILTERS.SAVE.BUTTON": "Sauvegarder la vue",
    "REPORTS_PAGE.CREATE_REPORT.BUTTON": "Créer un rapport",
    "REPORTS_PAGE.CREATE_REPORT.FORM.CHOOSE_LAYOUT.LABEL": "Choisir la mise en page",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REDIRECT_TO_EDIT": "Modifier le rapport",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.LABEL": "Nom du rapport",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.PLACEHOLDER": "Saisir le nom du rapport",
    "REPORTS_PAGE.CREATE_REPORT.FORM.SUBMIT": "Créer un rapport",
    "REPORTS_PAGE.CREATE_REPORT.TITLE": "Créer un nouveau rapport",
    "REPORTS_PAGE.CRUMB": "Rapports",
    "REPORTS_PAGE.SUBTITLE": "Rapports sur les résultats du balayage FIDO",
    "REPORTS_PAGE.TABLE.ACTIONS": "Actions",
    "REPORTS_PAGE.TABLE.CREATED": "Créée",
    "REPORTS_PAGE.TABLE.NUMBER": "#",
    "REPORTS_PAGE.TABLE.REPORT_NAME": "Nom du rapport",
    "REPORTS_PAGE.TITLE.NO_REPORTS": "Il n'y a pas de rapport",
    "REPORTS_PAGE.TITLE.TOTAL_COUNT": "Total des rapports :",
    "REQUEST.FAILED": "Échec",
    "REQUEST.SUCCESS": "Succès",
    "SERVER_ERRORS.-1": "Quelque chose n'a pas fonctionné",
    "SERVER_ERRORS.1": "Erreur de connexion à la base de données",
    "SERVER_ERRORS.10": "Erreur de fichier vide",
    "SERVER_ERRORS.11": "Erreur d'authentification",
    "SERVER_ERRORS.12": "Erreur d'authentification",
    "SERVER_ERRORS.13": "Erreur d'authentification",
    "SERVER_ERRORS.14": "Erreur d'authentification",
    "SERVER_ERRORS.15": "Erreur d'authentification",
    "SERVER_ERRORS.16": "L'utilisateur dont l'adresse électronique a été fournie n'a pas été trouvé",
    "SERVER_ERRORS.17": "L'adresse électronique ou le mot de passe est incorrect",
    "SERVER_ERRORS.18": "Le jeton d'adresse électronique n'est pas valide",
    "SERVER_ERRORS.19": "Permission refusée",
    "SERVER_ERRORS.2": "Une erreur s'est produite",
    "SERVER_ERRORS.21": "Utilisateur non trouvé",
    "SERVER_ERRORS.22": "Rôle non trouvé",
    "SERVER_ERRORS.23": "Entreprise non trouvée",
    "SERVER_ERRORS.24": "Projet non trouvé",
    "SERVER_ERRORS.25": "Permission refusée",
    "SERVER_ERRORS.26": "Permission refusée",
    "SERVER_ERRORS.27": "Données de fichier non valides",
    "SERVER_ERRORS.28": "Ce courriel existe déjà",
    "SERVER_ERRORS.3": "Requête invalide",
    "SERVER_ERRORS.31": "Entreprise non trouvée",
    "SERVER_ERRORS.32": "Le nom de l'entreprise n'est pas valide ou existe déjà",
    "SERVER_ERRORS.4": "Format de fichier invalide",
    "SERVER_ERRORS.41": "Entreprise non trouvée",
    "SERVER_ERRORS.5": "Non autorisé",
    "SERVER_ERRORS.6": "Ressource non trouvée",
    "SERVER_ERRORS.61": "Méthode non autorisée",
    "SERVER_ERRORS.62": "Échec de l'appel API",
    "SERVER_ERRORS.63": "Type de géométrie invalide",
    "SERVER_ERRORS.65": "Le projet chevauche les projets existants {{ projectNames }} et les DMAs {{ dmaKeys }}",
    "SERVER_ERRORS.7": "Service indisponible",
    "SERVER_ERRORS.8": "Erreur de stockage Azure",
    "SERVER_ERRORS.9": "Format geojson invalide",
    "SERVER_SUCCESS.ADD_COMPANY": "Création réussie d'une entreprise",
    "SERVER_SUCCESS.CREATE_BRANCH": "Projet créé avec succès",
    "SERVER_SUCCESS.CREATE_USER": "Utilisateur créé avec succès",
    "SERVER_SUCCESS.EDIT_COMPANY": "Mise à jour réussie de l'entreprise",
    "SERVER_SUCCESS.EDIT_USER": "Mise à jour de l'utilisateur réussie",
    "SERVER_SUCCESS.FORGOT_PASSWORD": "Envoi du lien de récupération réussi",
    "SERVER_SUCCESS.LOGIN": "La connexion a été effectuée avec succès",
    "SERVER_SUCCESS.LOGOUT": "La déconnexion a réussi",
    "SERVER_SUCCESS.RECOVERY": "La récupération s'est déroulée avec succès",
    "SERVER_SUCCESS.UPDATE_BRANCH": "Projet mis à jour avec succès",
    "SERVER_SUCCESS.UPDATE_REPORT": "Le rapport a été mis à jour",
    "SESSION_PAGE.ENGINEERING_DETAILS.3D_PLOT_TOGGLE_TITLE": "Séances de nuit séparées",
    "SESSION_PAGE.ENGINEERING_DETAILS.ADDRESS_TITLE": "Détails de l'adresse",
    "SESSION_PAGE.ENGINEERING_DETAILS.APPLY_DATES": "Appliquer les dates",
    "SESSION_PAGE.ENGINEERING_DETAILS.ASSET_TITLE": "Images d'actifs",
    "SESSION_PAGE.ENGINEERING_DETAILS.COLLECTED_ENGINEER": "Ingénieur collectionneur",
    "SESSION_PAGE.ENGINEERING_DETAILS.COMPANY": "Entreprise",
    "SESSION_PAGE.ENGINEERING_DETAILS.DATE_TITLE": "Date Heure",
    "SESSION_PAGE.ENGINEERING_DETAILS.DEPLOYED_ENGINEER": "Ingénieur déployé",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.ADDRESS": "Adresse",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.COMPANY": "Entreprise",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.CREATED": "Créée",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.DMA_KEY": "Clé DMA",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.END_TIME": "L'heure de la fin",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.FIDO_RESULT": "Résultat Fido",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LAST_UPDATE": "Dernière mise à jour",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LEAK_SIZE": "Taille de la fuite",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LOCATION": "Localisation",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SENSOR_ID": "ID du capteur",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_ID": "ID de la session",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_STATUS": "Statut de la session",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.START_TIME": "Heure de début",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.TYPE": "Type",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.WAYPOINT_NAME": "Nom du point de passage",
    "SESSION_PAGE.ENGINEERING_DETAILS.ENGINEER_TITLE": "Ingénieurs",
    "SESSION_PAGE.ENGINEERING_DETAILS.GRAPH_TITLE": "Graphique du pollen",
    "SESSION_PAGE.ENGINEERING_DETAILS.ID_TITLE": "Liste des ID",
    "SESSION_PAGE.ENGINEERING_DETAILS.LAST_UPDATED": "Jours depuis la dernière mise à jour",
    "SESSION_PAGE.ENGINEERING_DETAILS.POSTCODE": "Code postal",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_ERROR": "Une erreur s'est produite lors du traitement des données de relais",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_NO_DATA": "Aucune donnée n'est actuellement disponible",
    "SESSION_PAGE.ENGINEERING_DETAILS.RESET_DATES": "Dates de réinitialisation",
    "SESSION_PAGE.ENGINEERING_DETAILS.SESSION_TITLE": "Détails de la session",
    "SESSION_PAGE.ENGINEERING_DETAILS.TITLE": "Détails techniques FIDO",
    "SESSION_PAGE.ENGINEERING_DETAILS.WHAT3WORDS": "What3Words",
    "SESSION_PAGE.GET_AUDIO.BUTTON.CANCEL": "Annuler l'extraction",
    "SESSION_PAGE.GET_AUDIO.BUTTON.GET": "Récupérer l'audio",
    "SESSION_PAGE.GET_AUDIO.BUTTON.NA": "Aucun dispositif de relais disponible",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.CONTENT": "Pour pouvoir récupérer des données audio, il faut qu'un dispositif relais soit attaché à cette session. Si ce n'est pas le cas, vous ne pourrez pas récupérer de données audio via le portail pour cette session et le bouton sera désactivé.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.HEADING": "Disponibilité",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT1": "Quelle que soit la manière dont le relais a été déclenché, vous pouvez l'activer ou le désactiver à l'aide du bouton ci-dessus. Les dernières actions possibles et les statuts correspondants sont les suivants",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT2": "Déclenché par l'utilisateur du portail - Le dispositif de relais récupère les données audio.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT3": "Déclenché par l'utilisateur du portail - Le dispositif de relais ne récupère pas les données audio.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT4": "Déclenché par un processus automatisé - Le dispositif de relais récupère les données audio.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT5": "Déclenché OFF par un processus automatisé - Le dispositif de relais ne récupère pas les données audio.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT6": "N/A- Le dispositif de relais n'est pas disponible",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.TITLE": "Fonctionnalité",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT1": "Nous supposerons qu'il existe un dispositif de relais pour cette section.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT2": "Vous pouvez indiquer si le dispositif relais doit tenter de récupérer les données audio dans les 24 heures qui suivent.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT3": "Une fois la demande effectuée, les données de cette page seront mises à jour et la recherche audio sera automatiquement désactivée.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT4": "Il existe également un processus automatisé qui récupère automatiquement les données audio pour toutes les sessions auxquelles est attaché un dispositif relais, lorsque notre modèle a détecté un problème.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.HEADING": "Le processus",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.TITLE": "Explication des dispositifs à relais",
    "SESSION_PAGE.GET_AUDIO.ERROR": "Une erreur s'est produite, veuillez actualiser la page et réessayer.",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION": "Dernière action entreprise",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_OFF": "Déclenché OFF par un processus automatisé",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_ON": "Déclenchée par un processus automatisé",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.NA": "N/A",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_OFF": "Déclenché OFF par l'utilisateur du portail",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_ON": "Déclenché par l'utilisateur du portail",
    "SESSION_PAGE.GET_AUDIO.STATUS": "Statut actuel",
    "SESSION_PAGE.GET_AUDIO.STATUS.GET": "Le dispositif de relais récupère les données audio",
    "SESSION_PAGE.GET_AUDIO.STATUS.NA": "Dispositif de relais non disponible",
    "SESSION_PAGE.GET_AUDIO.STATUS.NOT_GET": "Le dispositif relais ne récupère pas l'audio",
    "SESSION_PAGE.GET_AUDIO.TITLE": "Extraction audio",
    "SESSION_PAGE.RELAY_GRAPH.X": "Fréquence",
    "SESSION_PAGE.RELAY_GRAPH.Y": "L'heure",
    "SESSION_PAGE.RELAY_GRAPH.Z": "Puissance",
    "SESSION_PAGE.SESSION_INFORMATION.FIDO_RESULT": "Résultat FIDO",
    "SESSION_PAGE.SESSION_INFORMATION.LEAK_SIZE": "Taille de la fuite",
    "SESSION_PAGE.SESSION_INFORMATION.TITLE": "Informations sur la session",
    "SESSION.LOADING_LEAK_MAPPER": "Chargement du module de cartographie des fuites...",
    "SESSIONS.STATUS.DELETED": "Supprimé",
    "SESSIONS.STATUS.ON_TRACK": "En bonne voie",
    "SESSIONS.STATUS.UPLOADED": "Téléchargé",
    "SESSIONS.STATUS.UPLOADING": "En attente de chargement",
    "SIDEBAR.ADMIN": "Admin",
    "SIDEBAR.BROWSE": "Parcourir",
    "SIDEBAR.COMPANIES": "Entreprises",
    "SIDEBAR.COMPANY": "Mon entreprise",
    "SIDEBAR.DASHBOARD": "Tableau de bord",
    "SIDEBAR.DELIVERY_PERFORMANCE": "Performances en matière de livraison",
    "SIDEBAR.DELIVERY_PERFORMANCE_LE": "Ingénieur fuites",
    "SIDEBAR.DELIVERY_PERFORMANCE_ST": "Technicien en capteurs",
    "SIDEBAR.DMAPERFORMANCEREPORT": "Rapport de performance DMA",
    "SIDEBAR.FEEDBACK": "Donner un retour d'information",
    "SIDEBAR.GIS": "SIG",
    "SIDEBAR.GIS_ADMIN": "Administrateur SIG",
    "SIDEBAR.GIS_UPLOAD": "Téléchargement du SIG",
    "SIDEBAR.LOGOUT": "Se déconnecter",
    "SIDEBAR.LOGS": "Journal des modifications",
    "SIDEBAR.PROJECT_ADMIN": "Administrateur de projet",
    "SIDEBAR.PROJECT_STATUS": "État d'avancement du projet",
    "SIDEBAR.PROJECTSTATUS": "État d'avancement du projet",
    "SIDEBAR.RELAY_MANAGEMENT": "Gestion des relais",
    "SIDEBAR.REPORTS": "Rapports",
    "SIDEBAR.SENSOR_MANAGEMENT": "Gestion des capteurs",
    "SIDEBAR.STOCK_MANAGEMENT": "Gestion des stocks",
    "SIDEBAR.TITLE": "Panneau d'administration",
    "SIDEBAR.USERS": "Gestion des utilisateurs",
    "SIDEBAR.VERSION": "Version ",
    "STOCK_MANAGEMENT.DATES_BETWEEN": "Afficher l'utilisation entre",
    "STOCK_MANAGEMENT.DATES_BETWEEN.AND": "et",
    "STOCK_MANAGEMENT.DISTRIBUTION.CHART_TITLE": "Distribution au client",
    "STOCK_MANAGEMENT.DISTRIBUTION.DATE_ERROR": "La date de début ne peut être supérieure à la date de fin",
    "STOCK_MANAGEMENT.DISTRIBUTION.FAULTY": "Capteurs FIDO défectueux",
    "STOCK_MANAGEMENT.DISTRIBUTION.FILTER": "Filtre",
    "STOCK_MANAGEMENT.DISTRIBUTION.NO_DATA": "Pas de données de distribution d'actions pour la plage de dates sélectionnée",
    "STOCK_MANAGEMENT.DISTRIBUTION.REFURBED": "Capteurs FIDO remis à neuf",
    "STOCK_MANAGEMENT.DISTRIBUTION.RETURNED": "Capteurs FIDO retournés",
    "STOCK_MANAGEMENT.DISTRIBUTION.STOCKED": "Capteurs FIDO en stock",
    "STOCK_MANAGEMENT.DISTRIBUTION.TITLE": "Distribution des stocks aux clients",
    "STOCK_MANAGEMENT.DISTRIBUTION.TOGGLE_ALL": "Toggle All",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.FAULTY": "Relais FIDO défectueux",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.REFURBED": "Relais FIDO remis à neuf",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.RETURNED": "Relais FIDO renvoyés",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.STOCKED": "Relais FIDO en stock",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.TITLE": "Distribution du relais aux clients",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.FAULTY": "Capteurs FIDO défectueux",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.REFURBED": "Capteurs FIDO remis à neuf",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.RETURNED": "Capteurs FIDO retournés",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.STOCKED": "Capteurs FIDO en stock",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.TITLE": "Distribution des capteurs aux clients",
    "STOCK_MANAGEMENT.TABLE.BUG_NAME": "Nom du capteur",
    "STOCK_MANAGEMENT.TABLE.BUG_OWNER": "Propriétaire du capteur",
    "STOCK_MANAGEMENT.TABLE.COMMENT": "Commentaire",
    "STOCK_MANAGEMENT.TABLE.CUSTOMER": "Client",
    "STOCK_MANAGEMENT.TABLE.DATE": "Dernière date",
    "STOCK_MANAGEMENT.TABLE.DATE_FROM": "De",
    "STOCK_MANAGEMENT.TABLE.DATE_TO": "Pour",
    "STOCK_MANAGEMENT.TABLE.DEVICE_ID": "ID du capteur",
    "STOCK_MANAGEMENT.TABLE.EDIT_SECTION": "Editer le stock",
    "STOCK_MANAGEMENT.TABLE.EDIT.COMMENTS": "Commentaires",
    "STOCK_MANAGEMENT.TABLE.EDIT.CUSTOMER": "Client",
    "STOCK_MANAGEMENT.TABLE.EDIT.DESELECT": "Désélectionner tous les stocks",
    "STOCK_MANAGEMENT.TABLE.EDIT.DISCARD": "Annuler",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_COMMENTS": "Veuillez saisir un commentaire",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_CUSTOMER": "Veuillez sélectionner un client",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_OWNER": "Veuillez sélectionner un propriétaire de capteur",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_STATUS": "Veuillez sélectionner un statut",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_TIMESTAMP": "Veuillez sélectionner un horodatage",
    "STOCK_MANAGEMENT.TABLE.EDIT.OWNER": "Propriétaire du capteur",
    "STOCK_MANAGEMENT.TABLE.EDIT.PARTNER": "Partenaire",
    "STOCK_MANAGEMENT.TABLE.EDIT.RELAY_OWNER": "Propriétaire de relais",
    "STOCK_MANAGEMENT.TABLE.EDIT.SENSOR_OWNER": "Propriétaire du capteur",
    "STOCK_MANAGEMENT.TABLE.EDIT.STATUS": "Statut",
    "STOCK_MANAGEMENT.TABLE.EDIT.SUBMIT": "Mise à jour",
    "STOCK_MANAGEMENT.TABLE.EDIT.TIMESTAMP": "Horodatage",
    "STOCK_MANAGEMENT.TABLE.EDIT.TITLE": "Modifier le stock sélectionné",
    "STOCK_MANAGEMENT.TABLE.FILTER": "Filtre",
    "STOCK_MANAGEMENT.TABLE.FILTER_SECTION": "Filtres, tri et recherche",
    "STOCK_MANAGEMENT.TABLE.MODIFY": "Modifier la sélection",
    "STOCK_MANAGEMENT.TABLE.NO_DATA": "Pas de données sur les stocks",
    "STOCK_MANAGEMENT.TABLE.PERSON": "Personne",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_NAME": "Nom du relais",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_OWNER": "Propriétaire de relais",
    "STOCK_MANAGEMENT.TABLE.RELAY.COMMENT": "Commentaire",
    "STOCK_MANAGEMENT.TABLE.RELAY.CUSTOMER": "Client",
    "STOCK_MANAGEMENT.TABLE.RELAY.DATE": "Dernière date",
    "STOCK_MANAGEMENT.TABLE.RELAY.IMEI": "IMEI",
    "STOCK_MANAGEMENT.TABLE.RELAY.PERSON": "Personne",
    "STOCK_MANAGEMENT.TABLE.RELAY.SIM": "ID SIM",
    "STOCK_MANAGEMENT.TABLE.RELAY.STATUS": "Statut",
    "STOCK_MANAGEMENT.TABLE.RELAY.TIMESTAMP": "Dernière heure",
    "STOCK_MANAGEMENT.TABLE.SEARCH_BAR.APPLY.FILTER": "Appliquer des filtres, trier et rechercher",
    "STOCK_MANAGEMENT.TABLE.SEARCH.PLACEHOLDER": "Recherche de capteurs...",
    "STOCK_MANAGEMENT.TABLE.SELECT_ALL": "Sélectionner tout",
    "STOCK_MANAGEMENT.TABLE.SELECT_WAYPOINT": "Sélectionner",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_NAME": "Nom du capteur",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_OWNER": "Propriétaire du capteur",
    "STOCK_MANAGEMENT.TABLE.SENSOR.COMMENT": "Commentaire",
    "STOCK_MANAGEMENT.TABLE.SENSOR.CUSTOMER": "Client",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DATE": "Dernière date",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DEVICE_ID": "ID du capteur",
    "STOCK_MANAGEMENT.TABLE.SENSOR.PERSON": "Personne",
    "STOCK_MANAGEMENT.TABLE.SENSOR.STATUS": "Statut",
    "STOCK_MANAGEMENT.TABLE.SENSOR.TIMESTAMP": "Dernière heure",
    "STOCK_MANAGEMENT.TABLE.SORT": "Trier",
    "STOCK_MANAGEMENT.TABLE.SORT.ASC": "Ascendante",
    "STOCK_MANAGEMENT.TABLE.SORT.DESC": "Descente",
    "STOCK_MANAGEMENT.TABLE.SORT.NONE": "Aucun",
    "STOCK_MANAGEMENT.TABLE.STATUS": "Statut",
    "STOCK_MANAGEMENT.TABLE.STATUSES.customer": "client",
    "STOCK_MANAGEMENT.TABLE.STATUSES.faulty": "défectueux",
    "STOCK_MANAGEMENT.TABLE.STATUSES.new": "nouveau",
    "STOCK_MANAGEMENT.TABLE.STATUSES.refurb": "remis à neuf",
    "STOCK_MANAGEMENT.TABLE.STATUSES.retired": "à la retraite",
    "STOCK_MANAGEMENT.TABLE.STATUSES.returned": "retourné",
    "STOCK_MANAGEMENT.TABLE.STATUSES.stock": "stock",
    "STOCK_MANAGEMENT.TABLE.TIMESTAMP": "Dernière heure",
    "STOCK_MANAGEMENT.TABLE.TITLE": "Tous les stocks",
    "SUMMARY.DIALOG.SUBTITLE.CHANGE": "Tous les filtres seront supprimés ?",
    "SUMMARY.DIALOG.SUBTITLE.CLOSE": "Les modifications seront supprimées",
    "SUMMARY.DIALOG.TITLE.CHANGE": "Êtes-vous sûr de vouloir modifier la source de données ?",
    "SUMMARY.DIALOG.TITLE.CLOSE": "Êtes-vous sûr de vouloir fermer les paramètres ?",
    "SUMMARY.FORM.COLUMN.LABEL": "Colonne",
    "SUMMARY.FORM.COLUMN.PLACEHOLDER": "Sélectionner une colonne",
    "SUMMARY.FORM.SOURCE.LABEL": "Source des données",
    "SUMMARY.FORM.SOURCE.PLACEHOLDER": "Sélectionner la source de données",
    "SUMMARY.FORM.TITLE.LABEL": "Titre",
    "SUMMARY.FORM.TITLE.PLACEHOLDER": "Saisir le titre",
    "SUMMARY.FORM.TYPE.LABEL": "Type",
    "SUMMARY.FORM.TYPE.PLACEHOLDER": "Sélectionner le type",
    "SUMMARY.MODAL_TITLE": "Paramètres",
    "SYSTEM_FIELDS.CELLS_FILLED": "Cellules remplies",
    "SYSTEM_FIELDS.DROPDOWN.1.PLACEHOLDER": "Choisir le matériau",
    "SYSTEM_FIELDS.DROPDOWN.2.PLACEHOLDER": "Choisir le type d'actif",
    "SYSTEM_FIELDS.DROPDOWN.3.PLACEHOLDER": "Choisir le type de tuyau",
    "SYSTEM_FIELDS.DROPDOWN.4.PLACEHOLDER": "Choisir le statut",
    "SYSTEM_FIELDS.DROPDOWN.5.PLACEHOLDER": "Choisir les unités",
    "SYSTEM_FIELDS.ERROR.NUMERIC_UNIQUE_FIELD": "Le champ unique saisi est numérique et doit être une chaîne de caractères.",
    "SYSTEM_FIELDS.ROW_1": "Champs de rangée",
    "SYSTEM_FIELDS.ROW_2": "Champs du système",
    "SYSTEM_FIELDS.TITLE": "Cartographier les cellules avec les champs du système",
    "SYSTEM_FIELDS.UNIQUE_VALUES_NOT_FOUND": "Pas de valeurs uniques à cartographier",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CHANGE": "Tous les filtres seront supprimés ?",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CLOSE": "Les modifications seront supprimées",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CHANGE": "Êtes-vous sûr de vouloir modifier la source de données ?",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CLOSE": "Êtes-vous sûr de vouloir fermer les paramètres ?",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.LABEL": "Colonne à afficher",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.PLACEHOLDER": "Sélectionner les colonnes",
    "TABLE_OF_RESULTS.FORM.SOURCE.LABEL": "Source des données",
    "TABLE_OF_RESULTS.FORM.SOURCE.PLACEHOLDER": "Sélectionner la source de données",
    "TABLE_OF_RESULTS.MODAL_TITLE": "Paramètres",
    "TOOLTIP.ADDRESS": "Adresse",
    "TOOLTIP.ASSET_KEY": "Clé des actifs",
    "TOOLTIP.COMPANY": "Entreprise",
    "TOOLTIP.CONSUMPTION_PROFILE_ID": "ID du profil de consommation",
    "TOOLTIP.DAYS_SINCE_LAST": "Jours depuis la dernière mise à jour",
    "TOOLTIP.DEPLOYED_BY": "Déployé par",
    "TOOLTIP.DEPLOYMENT_ORDER": "Ordre de déploiement",
    "TOOLTIP.DIAMETER": "Diamètre",
    "TOOLTIP.DMA_ID": "DMA Id",
    "TOOLTIP.DMA_KEY": "Clé DMA",
    "TOOLTIP.DMA_NAME": "Nom du DMA",
    "TOOLTIP.ENGINEER": "Ingénieur",
    "TOOLTIP.FIDO_RESULT": "Résultat Fido",
    "TOOLTIP.LATITUDE": "Latitude",
    "TOOLTIP.LEAK_SIZE": "Taille de la fuite",
    "TOOLTIP.LONGITUDE": "Longitude",
    "TOOLTIP.MATERIAL": "Matériau",
    "TOOLTIP.PIPE_TYPE": "Type de tuyau",
    "TOOLTIP.RECORDINGS_CNT": "Les enregistrements comptent",
    "TOOLTIP.SESSION_ID": "Id de la session",
    "TOOLTIP.STANDARDISED_MATERIAL": "Matériel standardisé",
    "TOOLTIP.STANDARISED_ASSET_TYPE": "Type d'actif normalisé",
    "TOOLTIP.TOP_SOUND_ID": "Sondage Supérieur ID",
    "TOOLTIP.WAYPOINT_ID": "Id du point de passage",
    "TOOLTIP.WAYPOINT_NAME": "Nom du point de passage",
    "TOOLTIP.WHAT_3_WORDS": "Quels sont les 3 mots ?",
    "TOP_SOUND_PAGE.AUDIO_INFORMATION": "Informations audio",
    "TOP_SOUND_PAGE.COMPANY": "Entreprise",
    "TOP_SOUND_PAGE.DISTANCE_GRAPH_TITLE": "Graphiques de distance",
    "TOP_SOUND_PAGE.ENGINEER": "Ingénieur",
    "TOP_SOUND_PAGE.HIGH_FREQUENCY": "coupure haute fréquence",
    "TOP_SOUND_PAGE.LOCATION": "Emplacement",
    "TOP_SOUND_PAGE.LOCATION_DETAILS": "Détails de l'emplacement",
    "TOP_SOUND_PAGE.LOW_FREQUENCY": "coupure basse fréquence",
    "TOP_SOUND_PAGE.NUMBER_PATHS": "Nombre de chemins",
    "TOP_SOUND_PAGE.POSTCODE": "Code postal",
    "TOP_SOUND_PAGE.PSDS_TITLE": "Profil spectral",
    "TOP_SOUND_PAGE.SPACING": "Espacement",
    "TOP_SOUND_PAGE.STARTING_DISTANCE": "Distance de départ",
    "TOP_SOUND_PAGE.TIME_TOP_SOUNDING": "Heure du sondage supérieur",
    "TOP_SOUND_PAGE.TITLE": "Sonorité supérieure",
    "TOP_SOUND_PAGE.WHAT3WORDS": "What3Words",
    "TOP_SOUNDING.GRAPH_ALT": "graphique de distance de sondage supérieure",
    "TOP_SOUNDING.PSD_GRAPH_ALT": "Graphe PSD",
    "UNIT.GALLONS_DAY": "Gallons/jour",
    "UNIT.ML_DAY": "ML/Jour",
    "UPLOAD_HEALTH_CHECK.BTN": "Télécharger le bilan de santé",
    "UPLOAD_HEALTH_CHECK.MODAL.BTN.SUBMIT": "Soumettre",
    "UPLOAD_HEALTH_CHECK.MODAL.DESC": "Veuillez saisir l'URL dans le champ ci-dessous",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.DESC": "Veuillez réessayer l'URL n'a pas été mise à jour",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.TITLE": "Réessayez !",
    "UPLOAD_HEALTH_CHECK.MODAL.INPUT.LABEL": "URL du bilan de santé",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.DESC": "L'URL du bilan de santé a été mis à jour",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.TITLE": "Génial !",
    "UPLOAD_HEALTH_CHECK.MODAL.TITLE": "Télécharger le rapport du bilan de santé",
    "USER_DETAILS_PAGE.CRUMB": "Gérer l'utilisateur",
    "USER_DETAILS_PAGE.DISCARD": "Rejeter",
    "USER_DETAILS_PAGE.FORM.BRANCH.LABEL": "Projet",
    "USER_DETAILS_PAGE.FORM.BRANCH.PLACEHOLDER": "Choisir un projet",
    "USER_DETAILS_PAGE.FORM.COMPANY.LABEL": "Entreprise",
    "USER_DETAILS_PAGE.FORM.COMPANY.PLACEHOLDER": "Choisir une entreprise",
    "USER_DETAILS_PAGE.FORM.EMAIL.LABEL": "Adresse électronique",
    "USER_DETAILS_PAGE.FORM.EMAIL.PLACEHOLDER": "Saisir l'adresse électronique",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.LABEL": "Prénom",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Saisir le prénom",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.LABEL": "Nom de famille",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Saisir le nom de famille",
    "USER_DETAILS_PAGE.FORM.ROLE.LABEL": "Rôle",
    "USER_DETAILS_PAGE.FORM.ROLE.PLACEHOLDER": "Choisir un rôle",
    "USER_DETAILS_PAGE.SUBMIT": "Économiser",
    "USER_MANAGEMENT.DROP_DOWN.TITLE": "Groupes",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_COMPANY": "Ajouter une entreprise",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PARTNER": "Ajouter un partenaire",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PROJECT": "Ajouter un projet",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_USER": "Ajouter un utilisateur",
    "USER_MANAGEMENT.ROUTE_TITLES.COMPANY": "Entreprise",
    "USER_MANAGEMENT.ROUTE_TITLES.PARTNER": "Partenaire",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT": "Projet",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT_ARCHIVES": "Projet archivé",
    "USER_MANAGEMENT.ROUTE_TITLES.RESOURCES": "Ressources",
    "USER_MANAGEMENT.ROUTE_TITLES.USER": "Utilisateur",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_COMPANIES": "Voir les entreprises",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_GIS_UPLOADS": "Afficher les téléchargements SIG",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PARTNERS": "Voir les partenaires",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECT_ARCHIVES": "Voir les archives",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECTS": "Voir les projets",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_USERS": "Voir les utilisateurs",
    "USER_ROLE.COMPANY_ADMIN": "Administrateur de l'entreprise",
    "USER_ROLE.COMPANY_BUG_DEPLOYMENT_ENGINEER": "Technicien en capteurs de l'entreprise",
    "USER_ROLE.COMPANY_LEAK_ENGINEER": "Entreprise Ingénieur fuites",
    "USER_ROLE.COMPANY_USER": "Utilisateur de l'entreprise",
    "USER_ROLE.PARTNER_ADMIN": "Partenaire Admin",
    "USER_ROLE.PARTNER_BUG_DEPLOYMENT_ENGINEER": "Technicien en capteurs partenaires",
    "USER_ROLE.PARTNER_LEAK_ENGINEER": "Partenaire Ingénieur Fuites",
    "USER_ROLE.PARTNER_USER": "Utilisateur partenaire",
    "USER_ROLE.SUPER_ADMIN": "Super Admin",
    "USERS_PAGE.ADD_USER.ACTIONS": "Actions",
    "USERS_PAGE.ADD_USER.BUTTON": "Nouvel utilisateur",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.LABEL": "Projet",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.PLACEHOLDER": "Choisir un projet",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.LABEL": "Entreprise",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.PLACEHOLDER": "Choisir une entreprise",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.LABEL": "Adresse électronique",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.PLACEHOLDER": "Saisir l'adresse électronique",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.LABEL": "Prénom",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.PLACEHOLDER": "Saisir le prénom",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.LABEL": "Nom de famille",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.PLACEHOLDER": "Saisir le nom de famille",
    "USERS_PAGE.ADD_USER.FORM.ROLE.LABEL": "Rôle",
    "USERS_PAGE.ADD_USER.FORM.ROLE.PLACEHOLDER": "Choisir un rôle",
    "USERS_PAGE.ADD_USER.FORM.SUBMIT": "Ajouter un utilisateur",
    "USERS_PAGE.ADD_USER.STATUS": "Statut",
    "USERS_PAGE.CRUMB": "Utilisateurs",
    "USERS_PAGE.DELETE_USER.TITLE": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    "USERS_PAGE.SUBTITLE": "D'autres informations importantes sont disponibles ici",
    "USERS_PAGE.TABLE.ACTIONS": "Actions",
    "USERS_PAGE.TABLE.COMPANY": "Entreprise",
    "USERS_PAGE.TABLE.EMAIL": "Courriel",
    "USERS_PAGE.TABLE.ID": "ID",
    "USERS_PAGE.TABLE.NAME": "Nom",
    "USERS_PAGE.TABLE.ROLE": "Rôle",
    "USERS_PAGE.TABLE.STATUS": "Statut",
    "USERS_PAGE.TITLE.NO_USERS": "Il n'y a pas d'utilisateurs",
    "USERS_PAGE.TITLE.TOTAL_COUNT": "Nombre total d'utilisateurs :",
    "VALIDATION.BRANCHES.UNIQUE": "Le nom du projet doit être unique",
    "VALIDATION.EMAIL": "Courriel invalide",
    "VALIDATION.MAX": "Doit être inférieur à %1$s caractères",
    "VALIDATION.PASSWORD.CONFIRM": "Le mot de passe et la répétition du mot de passe doivent être identiques",
    "VALIDATION.PASSWORD.LONG": "Le mot de passe doit comporter moins de 128 caractères",
    "VALIDATION.PASSWORD.SHORT": "Le mot de passe doit comporter plus de 8 caractères",
    "VALIDATION.PASSWORD.SPECIAL": "Le mot de passe doit contenir au moins un caractère spécial",
    "VALIDATION.PHONE": "Le téléphone est invalide",
    "VALIDATION.REQUIRED": "Exigée",
    "VIEW_COMPANIES.BUTTON.ADD": "Ajouter une entreprise",
    "VIEW_COMPANIES.DELETE_ICON": "Icône de suppression",
    "VIEW_COMPANIES.EDIT_ICON": "Icône d'édition",
    "VIEW_COMPANIES.TITLE.ACTION": "Action",
    "VIEW_COMPANIES.TITLE.COMPANY_CODE": "Code de l'entreprise",
    "VIEW_COMPANIES.TITLE.COUNTRY": "Code pays",
    "VIEW_COMPANIES.TITLE.CURRENCY": "Monnaie",
    "VIEW_COMPANIES.TITLE.LIST": "Liste des entreprises",
    "VIEW_COMPANIES.TITLE.NAME": "Nom",
    "VIEW_COMPANIES.TITLE.PAGE": "Voir les entreprises",
    "VIEW_COMPANIES.TITLE.PARTNER": "Partenaire",
    "VIEW_COMPANIES.TITLE.UNIT": "Unité",
    "VIEW_DRAFTS.DIALOG.DELETE.CANCEL": "Mépris",
    "VIEW_DRAFTS.DIALOG.DELETE.CONFIRM": "Supprimer",
    "VIEW_DRAFTS.DIALOG.DELETE.TITLE": "Êtes-vous sûr de vouloir supprimer ce brouillon ?",
    "VIEW_DRAFTS.TITLE.PAGE": "Afficher les brouillons",
    "VIEW_PARTNERS.BUTTON.ADD": "Ajouter un partenaire",
    "VIEW_PARTNERS.TITLE.ACTION": "Action",
    "VIEW_PARTNERS.TITLE.COUNTRY": "Code pays",
    "VIEW_PARTNERS.TITLE.LIST": "Liste des partenaires",
    "VIEW_PARTNERS.TITLE.NAME": "Nom",
    "VIEW_PARTNERS.TITLE.PAGE": "Voir les partenaires",
    "VIEW_PARTNERS.TITLE.PARTNER_CODE": "Code partenaire",
    "VIEW_PROJECT_ARCHIVES.DESCRIPTION": "Pour réactiver un projet, veuillez contacter le support.",
    "VIEW_PROJECTS.ACTION.APPROVE": "Approuver",
    "VIEW_PROJECTS.ACTION.ARCHIVE": "Archive",
    "VIEW_PROJECTS.ACTION.DECLINE": "Déclin",
    "VIEW_PROJECTS.ACTION.DELETE": "Supprimer",
    "VIEW_PROJECTS.ACTION.EDIT": "Modifier",
    "VIEW_PROJECTS.ACTION.REJECT": "Rejeter",
    "VIEW_PROJECTS.ACTION.VIEW": "Voir",
    "VIEW_PROJECTS.ACTION.VIEW_REJECTION_NOTES": "Afficher les notes de rejet",
    "VIEW_PROJECTS.BUTTON.ADD": "Ajouter un projet",
    "VIEW_PROJECTS.DIALOG.APPROVE.CANCEL": "Mépris",
    "VIEW_PROJECTS.DIALOG.APPROVE.CONFIRM": "Approuver",
    "VIEW_PROJECTS.DIALOG.APPROVE.TITLE": "Êtes-vous sûr de vouloir approuver ce projet ?",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CANCEL": "Mépris",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CONFIRM": "Confirmer",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.DESCRIPTION": "Une fois le projet déplacé vers l'archive, les fichiers, points de cheminement et sessions associés seront inactifs et inaccessibles. Pour réactiver un projet, vous pouvez ouvrir un ticket d'assistance.",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.TITLE": "Êtes-vous sûr de vouloir archiver ce projet ?",
    "VIEW_PROJECTS.DIALOG.DELETE.CANCEL": "Mépris",
    "VIEW_PROJECTS.DIALOG.DELETE.CONFIRM": "Supprimer",
    "VIEW_PROJECTS.DIALOG.DELETE.TITLE": "Êtes-vous sûr de vouloir supprimer ce projet ?",
    "VIEW_PROJECTS.DIALOG.REJECT.CANCEL": "Mépris",
    "VIEW_PROJECTS.DIALOG.REJECT.CONFIRM": "Rejeter",
    "VIEW_PROJECTS.DIALOG.REJECT.TITLE": "Êtes-vous sûr de vouloir rejeter ce projet ?",
    "VIEW_PROJECTS.FORM.FILTER.ALL": "Tous",
    "VIEW_PROJECTS.FORM.FILTER.APPROVED": "Approuvé",
    "VIEW_PROJECTS.FORM.FILTER.SUBMITTED": "Soumis",
    "VIEW_PROJECTS.NOT_FOUND": "Aucun projet trouvé",
    "VIEW_PROJECTS.TITLE.ACTION": "Action",
    "VIEW_PROJECTS.TITLE.AUTHOR": "Créé par",
    "VIEW_PROJECTS.TITLE.COMPANY": "Entreprise",
    "VIEW_PROJECTS.TITLE.DMAS": "Voir les DMA",
    "VIEW_PROJECTS.TITLE.DMAS_SUBLIST_TITLE": "Liste des DMA",
    "VIEW_PROJECTS.TITLE.END_DATE": "Date de fin",
    "VIEW_PROJECTS.TITLE.LIST": "Liste des projets",
    "VIEW_PROJECTS.TITLE.NAME": "Nom",
    "VIEW_PROJECTS.TITLE.NO_DMAS": "Pas de DMA",
    "VIEW_PROJECTS.TITLE.PAGE": "Voir les projets",
    "VIEW_PROJECTS.TITLE.START_DATE": "Date de début",
    "VIEW_PROJECTS.TITLE.STATUS": "Statut",
    "VIEW_USERS.ACTION.DELETE": "Supprimer",
    "VIEW_USERS.ACTION.EDIT": "Modifier",
    "VIEW_USERS.ACTION.FORGOT_PASSWORD": "Réinitialiser le mot de passe",
    "VIEW_USERS.BUTTON.ADD": "Ajouter un utilisateur",
    "VIEW_USERS.BUTTON.INVITE": "Inviter un utilisateur",
    "VIEW_USERS.PAGINATION.TITLE": "Lignes par page",
    "VIEW_USERS.ROW.ICON.DELETE.ALT": "Icône de suppression",
    "VIEW_USERS.ROW.ICON.EDIT.ALT": "Icône d'édition",
    "VIEW_USERS.TITLE.LIST": "Liste des utilisateurs",
    "VIEW_USERS.TITLE.PAGE": "Voir les utilisateurs",
    "VIEW_USERS.TITLE.ROW_FIVE": "Action",
    "VIEW_USERS.TITLE.ROW_FOUR": "Rôle",
    "VIEW_USERS.TITLE.ROW_ONE": "Nom",
    "VIEW_USERS.TITLE.ROW_THREE": "Entreprise",
    "VIEW_USERS.TITLE.ROW_TWO": "Partenaire",
    "WAYPOINT_PAGE.ADD_JOB.ADDRESS": "Adresse",
    "WAYPOINT_PAGE.ADD_JOB.DATE_EXTERNALLY": "Date de l'alerte externe",
    "WAYPOINT_PAGE.ADD_JOB.DATE_INTERNALLY": "Date de l'enquête interne",
    "WAYPOINT_PAGE.ADD_JOB.DESCRIPTION": "Ajouter une tâche au point de passage",
    "WAYPOINT_PAGE.ADD_JOB.DISCARD": "Rejeter",
    "WAYPOINT_PAGE.ADD_JOB.ENGINEERING_NOTE": "Note d'ingénierie",
    "WAYPOINT_PAGE.ADD_JOB.ENVIRONMENTAL_NOTE": "Note sur l'environnement",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.DESC": "Veuillez actualiser et réessayer",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.TITLE": "Quelque chose n'a pas fonctionné",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE": "Taille estimée de la fuite",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE_UNIT": "Unité de taille de fuite",
    "WAYPOINT_PAGE.ADD_JOB.FLOW_REDUCTION": "Réduction du débit convenu (m3/hr)",
    "WAYPOINT_PAGE.ADD_JOB.IMAGE_ALT": "Image téléchargée %1$s",
    "WAYPOINT_PAGE.ADD_JOB.IMAGES": "Médias",
    "WAYPOINT_PAGE.ADD_JOB.JOB_COMMENT": "Notes",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS": "Statut de l'emploi",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.CANCELLED": "Annulé",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG": "Creuser à sec",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG_APPEALED": "Appel de la décision Dry Dig",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.NFA": "NFA (Pas d'action ultérieure)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.PLACEHOLDER": "Sélectionner un statut de travail",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_EXTERNALLY": "Relevés à l'extérieur",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_INTERNALLY": "Relevés en interne",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.REPAIRED": "Réparation",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RFA": "RFA (Request further action)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.VALIDATION": "Veuillez indiquer le statut de l'emploi",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE": "Type d'emploi",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.ASSET_VALVE_HYDRANT_LEAK": "Fuite d'un bien (vanne/hydrant)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Fuite du compteur du client/PRV",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.COMM_PIPE_LEAK": "Fuite du tuyau de Comm",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_METER_LEAK": "Fuite du compteur du client",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Fuite côté client",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.FERRULE_LEAK": "Fuite de la virole",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.MAINS_LEAK": "Fuite de réseau",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.NETWORK_MAINTENANCE": "Maintenance du réseau",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.PLACEHOLDER": "Sélectionner un type d'emploi",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RENEW_STOP_TAP_MSM": "Renouveler le robinet d'arrêt/MSM",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RESOLVED_ONSITE": "Résolu sur place",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.VALIDATION": "Veuillez indiquer un type d'emploi",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_ESTIMATE": "Estimation de la taille de la fuite par le client",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE": "Type de fuite",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.ASSET_LEAK": "Fuite d'actifs",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Fuite du compteur du client/de la PRV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMERCIAL_REPAIR": "Réparation commerciale",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMUNICATION_PIPE": "Tuyau de communication",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CSL": "CSL",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_METER_LEAK": "Fuite du compteur du client",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Fuite côté client",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.DECOMMISSION_FERRULE": "Embout de déclassement",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Excavation d'un trou d'essai (permis)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Compteur de fuites externe>40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Compteur de fuites externe>40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Compteur de fuites externe<40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Compteur de fuites externe<40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FERRULE": "Embout",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H arrêté sur place",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_HYDRANT": "Bouche d'incendie",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_MAIN": "Feu principal",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Essai d'écoulement à la frontière No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Essai d'écoulement à la frontière avec Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Inst MSM to Exist Comm Pipe UnMtrd",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_FERRULE_ONLY": "Installer la virole uniquement",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_MSM_INC_METER": "Installer le compteur MSM Inc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SAMPLE_TAP": "Installer un robinet d'échantillonnage",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SLUICE_VALVE": "Installer la vanne d'écluse",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Installation d'une bouche d'égout",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_FIXED_ONSITE": "Fuite réparée sur place",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_FH": "Fuite sur F/H ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Fuite sur l'axe du SV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Fuite au niveau de la broche de SV / de la bride. ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS": "Principaux",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_BURST": "Eclatement du réseau ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_LEAK": "Fuite de réseau",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/A - Sans arrêt sur site ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NETWORK_MAINTENANCE": "Maintenance du réseau",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NO_LEAK": "Pas de fuite",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OSV_EXCHANGE": "OSV Exchange",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OTHER": "Autres",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_FH": "Passant FH",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_HYDRANT": "Passage d'une borne d'incendie",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PLACEHOLDER": "Sélectionner un type de fuite",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Travaux d'assainissement Extérieur",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Enlever la vanne d'écluse",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Renouveler le tuyau de communication Longside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Renew Communication Pipe Shortside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COVER_FRAME_STANDARD": "Renouveler la couverture et le cadre (standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FERRULE_ONLY": "Renouveler l'embout seulement",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT": "Renouvellement d'une bouche d'incendie",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Renouvellement de la chambre des bouches d'incendie",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_COVER": "Renouveler le cadre et le couvercle de la bouche d'incendie",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Renouveler un tuyau d'alimentation qui fuit >10m",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Renouveler un tuyau d'alimentation qui fuit <10m ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Renouveler l'assemblage MSM/ robinet d'arrêt",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_SLUICE_VAVLE": "Renew Sluice Vavle",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Renouvellement d'une bouche d'égout",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPACK_SLUICE_VALVE": "Remplissage de la vanne d'écluse",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Réparation du tuyau de communication",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Réparation du FSL externe - Non éligible",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Réparer une fuite interne (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Réparation d'un tuyau d'alimentation qui fuit (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LOP": "Réparation LOP",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Réparation du FSL - Eligible",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Réparation de la pièce de fixation principale >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Réparation Pièce de cheville principale <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Réparation de la tige [pas de goujon] >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Réparateur principal [pas de goujon] <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAJOR_BURST": "Réparation d'une rupture majeure",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Réparation du clapet de non-retour",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Réparation du trop-plein (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_SLUICE_VALVE": "Réparation de la vanne d'écluse",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Repositionnement de l'assemblage MSM/tampon d'arrêt",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Boîte de surface à réarmement (standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SERVICE_LEAK": "Fuite de service",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE": "Vanne d'écluse",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE_VL": "Soupape à guillotine (VL)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_EXCHANGE": "Échange de robinets d'arrêt",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK": "Arrêter la fuite du robinet",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK_NO_7_FERRULE_EXCHANGE_NO_5": "Fuite du robinet d'arrêt n° 7\\n\\nChangement de virole No.5",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.VALIDATION": "Veuillez indiquer le type de fuite",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.WO_FH": "WO / FH",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER": "Diamètre du tube",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER_UNIT": "Unité de diamètre",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_MATERIAL": "Matériau du tube",
    "WAYPOINT_PAGE.ADD_JOB.REMOVE_IMAGE_ARIA": "Supprimer l'image %1$s",
    "WAYPOINT_PAGE.ADD_JOB.REPAIR_DATE": "Date de réparation",
    "WAYPOINT_PAGE.ADD_JOB.ROAD_SPEED": "Vitesse de la route",
    "WAYPOINT_PAGE.ADD_JOB.SELECT_UNIT.PLACEHOLDER": "Sélectionner l'unité",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT": "Ajouter un nouvel emploi",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT.VALIDATION": "La validation a échoué, veuillez vérifier les entrées.",
    "WAYPOINT_PAGE.ADD_JOB.SUCCESS": "Ajout d'un emploi réussi",
    "WAYPOINT_PAGE.ADD_JOB.SURFACE_TYPE": "Type de surface",
    "WAYPOINT_PAGE.ADD_JOB.TITLE": "Ajouter un emploi à Waypoint",
    "WAYPOINT_PAGE.ADD_JOB.W3W": "What3Words",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER": "Référence de l'ordre de travail du client/de l'entreprise de service public",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER.VALIDATION": "Veuillez fournir la référence d'un ordre de travail d'un client ou d'un service public.",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.ACTION": "Action",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.DATE": "Date",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.address": "Adresse",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.agreed_flow_reduction": "Réduction du débit",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.comment": "Commentaire",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_externally": "Date de l'alerte externe",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_internally": "Date de l'enquête interne",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.environmental_notes": "Notes sur l'environnement",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.estimate_leak_size": "Taille estimée de la fuite",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.id": "ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_status": "Statut de l'emploi",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_type": "Type d'emploi",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.leak_type_id": "Type de fuite ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.material": "Matériau",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.pipe_diameter": "Diamètre du tube",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.repair_date": "Date de réparation",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.road_speed": "Vitesse de la route",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.surface_type": "Type de surface",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.urls": "URL",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.w3w": "W3W",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.waypoint_id": "ID du point de passage",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.work_order": "Référence de l'ordre de travail du client/de l'entreprise de service public",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NEW": "Nouvelle valeur",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NOTES": "Notes complémentaires",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.OLD": "Valeur précédente",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.STATUS": "Statut",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.TITLE": "Journaux de travail",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.USER": "Utilisateur",
    "WAYPOINT_PAGE.JOB_TABLE.CREATED_DATE": "Date de création",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_ERROR": "La date de début doit être antérieure à la date de fin",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE": "Date Type",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE.PLACEHOLDER": "Sélectionner le type de date",
    "WAYPOINT_PAGE.JOB_TABLE.END_DATE": "Date de fin",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Asset (Valve/Hydrant) Leak": "Fuite d'un bien (vanne/hydrant)",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Cancelled": "Annulé",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Client Meter/PRV Leak": "Fuite du compteur du client/PRV",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Comm Pipe Leak": "Fuite du tuyau de Comm",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Customer Meter Leak": "Fuite du compteur du client",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Ferrule Leak": "Fuite de la virole",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Leak Repair": "Réparation des fuites",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Mains Leak": "Fuite de réseau",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised externally": "Relevés à l'extérieur",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised internally": "Relevés en interne",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Repaired": "Réparation",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Scheduled": "Prévu",
    "WAYPOINT_PAGE.JOB_TABLE.FILTERS": "Filtres, tri et recherche",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.CREATED": "Date de création",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.FLOW_REDUCTION": "Réduction du débit convenue",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_COMMENTS": "Notes",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_STATUS": "Statut de l'emploi",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_TYPE": "Type d'emploi",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_SIZE": "Taille de la fuite",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_TYPE": "Type de fuite",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.REPAIR_DATE": "Date de réparation",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.UPDATED_DATE": "Date de mise à jour",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.WORK_ORDER": "Référence de l'ordre de travail du client/de l'entreprise de service public",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA": "Aucun emploi correspondant",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA_EXISTS": "Aucun emploi n'existe pour ce point de passage",
    "WAYPOINT_PAGE.JOB_TABLE.REPAIR_DATE": "Date de réparation",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.BUTTON": "Appliquer des filtres, trier et rechercher",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.PLACEHOLDER": "Rechercher des emplois...",
    "WAYPOINT_PAGE.JOB_TABLE.START_DATE": "Date de début",
    "WAYPOINT_PAGE.JOB_TABLE.TITLE": "Emplois pour Waypoint",
    "WAYPOINT_PAGE.JOB_TABLE.UPDATED_DATE": "Date de mise à jour",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ACTUAL_LEAK_TYPE": "Type de fuite réelle",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADD_JOB": "Ajouter un emploi",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADDRESS": "Adresse",
    "WAYPOINT_PAGE.WAYPOINT_INFO.AI_PREDICTED_LEAK_SIZE": "L'IA a prédit la taille de la fuite",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ASSIGNED_ENGINEER": "Ingénieur désigné",
    "WAYPOINT_PAGE.WAYPOINT_INFO.BTN_MERGE": "Fusionner les points de repère",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CANCEL": "Annuler",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CNS": "CNS",
    "WAYPOINT_PAGE.WAYPOINT_INFO.COMMENT": "Note d'ingénierie",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CURRENT_STATUS": "Statut",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER": "Diamètre",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER_UNIT": "Unité de diamètre",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_NAME": "Nom du DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_REFERENCE": "Référence DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.EDIT_FIELDS": "Modifier les champs",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ENVIRONMENTAL_NOTES": "Notes sur l'environnement",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE": "Réduction du débit convenu",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT": "Estimation de la taille de la fuite par le client",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT_UNIT": "Unité d'estimation de la taille de fuite du client",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER": "Estimation de la taille des fuites sur site",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER_UNIT": "Unité d'estimation de la taille des fuites sur site",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_UNIT": "Unité de réduction de débit convenue",
    "WAYPOINT_PAGE.WAYPOINT_INFO.JOB_TYPE_CODE": "Code du travail",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_SCHEDULED_ENGINEER": "Ingénieur désigné",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_UPDATE": "Jours depuis la dernière mise à jour",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LEAK_TYPE": "Type de fuite",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PIPE_MATERIAL": "Matériau du tube",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.DATE": "Sélectionner la date",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.ENGINEER": "Affecter un ingénieur",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.JOB_TYPE_CODE": "Sélectionnez le code de travail",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.LEAK_TYPE": "Sélectionner le type de fuite",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.MATERIAL": "Matériau du tube",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.STATUS": "Sélectionner le statut",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_LEAK_SIZE": "Estimation du type de fuite sur site",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_SIZE": "Taille prévue",
    "WAYPOINT_PAGE.WAYPOINT_INFO.REPAIR_TIME": "Date de la fouille",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SUBMIT": "Économiser",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SURFACE_TYPE": "Type de surface",
    "WAYPOINT_PAGE.WAYPOINT_INFO.TITLE": "Informations sur les points de passage",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WAYPOINT_NAME": "Nom du point de passage",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT_3_WORDS": "Quels sont les 3 mots",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT3WORDS": "What3Words",
    "WAYPOINT_SIZE_WIDGET.DAY": "Jour",
    "WAYPOINT_SIZE_WIDGET.DAY_other": "Jours",
    "WAYPOINT_SIZE_WIDGET.NO_NAME": "Aucun",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_A": "Dernière fuite",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_B": "Fuite la plus longue",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_C": "La plus grande fuite",
    "WAYPOINT_SIZE_WIDGET.TITLE": "Points de repère",
    "WIDGET_LAYOUT.CANCEL_TEXT": "Non",
    "WIDGET_LAYOUT.CONFIRM_TEXT": "Oui",
    "WIDGET_LAYOUT.FILTERS": "Filtres",
    "WIDGET_LAYOUT.MAP_VIEW": "Voir la carte",
    "WIDGET_LAYOUT.REMOVE_WIDGET": "Supprimer le widget",
    "WIDGET_LAYOUT.SETTINGS": "Paramètres",
    "WIDGET_LAYOUT.SUBTITLE": "Tous les réglages seront supprimés",
    "WIDGET_LAYOUT.SUMMARY": "Résumé",
    "WIDGET_LAYOUT.TABLE_OF_RESULTS": "Tableau des résultats",
    "WIDGET_LAYOUT.TITLE": "Êtes-vous sûr de vouloir supprimer ce widget ?",
    "BROWSE_VIEW.RELAY.UPTIME": "Temps de disponibilité du relais",
    "BROWSE_VIEW.WAYPOINT.EDIT": "modifier",
    "BROWSE_VIEW.WAYPOINT.MERGE_W": "Fusionner les points de cheminement",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA": "Médias",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA_EMPTY": "Aucun média pour ce point de cheminement",
    "BROWSE_VIEW.WAYPOINT.SHARE": "partager",
    "BROWSE.FILTERS.PREDICTED_SIZE.NO_PREDICTION": "Aucune prédiction",
    "BROWSE.FILTERS.UPTIME": "Disponibilité",
    "BROWSE.FILTERS.UPTIME_PLACEHOLDER": "Sélectionner les temps de disponibilité",
    "BROWSE.FILTERS.UPTIME.AVERAGE": "Moyenne",
    "BROWSE.FILTERS.UPTIME.GOOD": "Bien",
    "BROWSE.FILTERS.UPTIME.HIGH": "Haut",
    "BROWSE.FILTERS.UPTIME.LOW": "Faible",
    "BROWSE.FILTERS.UPTIME.MEDIUM": "Moyen",
    "BROWSE.FILTERS.UPTIME.POOR": "Pauvre",
    "BROWSE.TABLE.COLUMNS.UPTIME": "Disponibilité"
  }
}
